var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13736",
    "data-name": "Group 13736",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 558.451,
    height: 507.965,
    viewBox: "0 0 558.451 507.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.923,
    y1: -0.154,
    x2: 0.201,
    y2: 0.964,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#d7e6fd",
    stopOpacity: 0.694
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#bdcefa",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.356,
    y1: 0.077,
    x2: 0.613,
    y2: 0.832,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.522,
    y1: -0.316,
    x2: 0.494,
    y2: 0.715,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.672,
    y1: -0.424,
    x2: 0.424,
    y2: 0.907,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1.266,
    y1: 0.082,
    x2: -0.389,
    y2: 0.986,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#e1efff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#c7d7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#bdcefa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2.616,
    y1: -0.364,
    x2: -0.059,
    y2: 0.728,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.999,
    y1: -0.079,
    x2: -1.053,
    y2: 2.339,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1.929,
    y1: -1.071,
    x2: 0.204,
    y2: 0.827,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.949,
    y1: 0.025,
    x2: -0.976,
    y2: 2.101,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2.523,
    y1: -1.053,
    x2: 0.374,
    y2: 0.597,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1.086,
    y1: -0.235,
    x2: -0.069,
    y2: 1.234,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1.628,
    y1: 0.756,
    x2: 0.947,
    y2: 0.602,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.963,
    y1: 0.039,
    x2: -2.037,
    y2: 3.025,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1.973,
    y1: 1.077,
    x2: 0.197,
    y2: 0.381,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1.367,
    y1: 0.439,
    x2: 0.012,
    y2: 0.514,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1.008,
    y1: 0.892,
    x2: 0.114,
    y2: 0.08,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -0.304,
    y1: 1.453,
    x2: 1.201,
    y2: -0.33,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f123b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#141754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#1b1f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347,
    stopColor: "#212699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#262bb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#292ec3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#2b30ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#2c31d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.908,
    y1: -0.062,
    x2: -0.09,
    y2: 0.803,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 798.838,
    y1: -1899.446,
    x2: -797.489,
    y2: 1898.745,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1.153,
    y1: 0.291,
    x2: 0.218,
    y2: 0.617,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfdff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#fbfdd7",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#f8fe8c",
    stopOpacity: 0.365
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#f6fe50",
    stopOpacity: 0.584
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f5ff24",
    stopOpacity: 0.773
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#f4ff0a",
    stopOpacity: 0.914
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#f4ff00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -6.074,
    y1: 3.198,
    x2: 3.032,
    y2: -0.54,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfdff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#fdb2ce",
    stopOpacity: 0.278
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#fe77a7",
    stopOpacity: 0.525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#fe4b8b",
    stopOpacity: 0.737
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#ff3179",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#ff2773"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -6.849,
    y1: 3.506,
    x2: 2.256,
    y2: -0.217,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -7.625,
    y1: 3.823,
    x2: 1.481,
    y2: 0.099,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -0.093,
    y1: 0.981,
    x2: 1.668,
    y2: -0.448,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -0.243,
    y1: 1.104,
    x2: 1.518,
    y2: -0.327,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -0.393,
    y1: 1.226,
    x2: 1.368,
    y2: -0.206,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 7.702,
    y1: -2.73,
    x2: -2.656,
    y2: 1.916,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 8.514,
    y1: -3.094,
    x2: -1.844,
    y2: 1.552,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 9.326,
    y1: -3.457,
    x2: -1.032,
    y2: 1.189,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1.227,
    y1: -0.152,
    x2: -0.765,
    y2: 1.634,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1.383,
    y1: -0.292,
    x2: -0.609,
    y2: 1.494,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1.539,
    y1: -0.431,
    x2: -0.452,
    y2: 1.353,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1.039,
    y1: -0.125,
    x2: 0.027,
    y2: 1.049,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1.231,
    y1: -1.423,
    x2: 0.382,
    y2: 0.809,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1.311,
    y1: -0.578,
    x2: -0.062,
    y2: 1.246,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.968,
    y1: -0.234,
    x2: 0.147,
    y2: 1.052,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1.25,
    y1: -0.515,
    x2: -0.048,
    y2: 1.242,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1.174,
    y1: -0.413,
    x2: -0.125,
    y2: 1.346,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 3.553,
    y1: -1.056,
    x2: -1.283,
    y2: 1.408,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 2.462,
    y1: -0.5,
    x2: -2.375,
    y2: 1.965,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1.37,
    y1: 0.057,
    x2: -3.466,
    y2: 2.521,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1.047,
    y1: -0.018,
    x2: -0.897,
    y2: 1.827,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1.811,
    y1: -0.37,
    x2: 0.048,
    y2: 0.8,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1.127,
    y1: 0.677,
    x2: -0.101,
    y2: 0.331,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0c0f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13625",
    "data-name": "Group 13625",
    transform: "translate(37.209 240.488)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5715",
    "data-name": "Path 5715",
    d: "M658.93,359.785,572.5,402.878c-3.825,1.974-10.58,1.72-14.995-.561L528.76,387.053c-4.415-2.263-4.9-5.74-1.078-7.713l86.1-43.945c3.825-1.974,10.58-1.72,14.995.561l29.074,16.133C662.287,354.353,662.775,357.811,658.93,359.785Z",
    transform: "translate(-174.564 -151.576)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5716",
    "data-name": "Path 5716",
    d: "M641.25,338.995l-86.427,43.094c-3.825,1.974-10.58,1.72-14.995-.561L511.08,366.263c-4.415-2.263-4.9-5.74-1.078-7.713l86.081-43.944c3.825-1.974,10.58-1.72,14.995.561L640.151,331.3C644.586,333.563,645.075,337.039,641.25,338.995Z",
    transform: "translate(-192.854 -168.429)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5717",
    "data-name": "Path 5717",
    d: "M821.9,340.272,561.087,469.752c-11.556,5.939-31.922,5.178-45.269-1.666l-151.96-78.075c-13.347-6.862-14.811-17.328-3.255-23.249l260.808-129.48c11.556-5.939,31.922-5.178,45.269,1.666l151.96,78.075C831.987,323.886,833.431,334.352,821.9,340.272Z",
    transform: "translate(-352.809 -233.279)",
    fill: "#bdcefa"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13634",
    "data-name": "Group 13634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13626",
    "data-name": "Group 13626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5718",
    "data-name": "Path 5718",
    d: "M337.612,242.795a2.953,2.953,0,0,1-3.092-2.752V182.011a2.7,2.7,0,0,1,1.546-2.372l78.371-40.269a3.271,3.271,0,0,1,1.526-.38,2.952,2.952,0,0,1,3.092,2.752v58.031a2.7,2.7,0,0,1-1.546,2.372l-78.371,40.269A3.271,3.271,0,0,1,337.612,242.795Z",
    transform: "translate(-334.52 -69.226)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5719",
    "data-name": "Path 5719",
    d: "M368.172,342.236c-3.174,0-6.592-2.245-6.592-5.866V212.249a5.8,5.8,0,0,1,3.3-5.07l167.646-86.133a7.191,7.191,0,0,1,3.276-.8c3.174,0,6.592,2.245,6.592,5.867v124.12a5.8,5.8,0,0,1-3.3,5.07L371.448,341.439A7.19,7.19,0,0,1,368.172,342.236Z",
    transform: "translate(-306.525 -84.417)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5720",
    "data-name": "Path 5720",
    d: "M431.106,192.423A2.593,2.593,0,0,1,428.38,190V138.574a2.406,2.406,0,0,1,1.363-2.1L499.2,100.786a2.945,2.945,0,0,1,1.363-.326,2.593,2.593,0,0,1,2.726,2.426v51.422a2.406,2.406,0,0,1-1.363,2.1L432.47,192.1A3.008,3.008,0,0,1,431.106,192.423Z",
    transform: "translate(-237.418 -100.46)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5721",
    "data-name": "Path 5721",
    d: "M351.476,305.3a2.593,2.593,0,0,1-2.726-2.426V251.454a2.406,2.406,0,0,1,1.363-2.1l69.459-35.688a2.946,2.946,0,0,1,1.363-.326,2.593,2.593,0,0,1,2.726,2.426v51.422a2.407,2.407,0,0,1-1.363,2.1l-69.459,35.688A3.007,3.007,0,0,1,351.476,305.3Z",
    transform: "translate(-319.799 -8.954)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13630",
    "data-name": "Group 13630",
    transform: "translate(83.274 74.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13627",
    "data-name": "Group 13627",
    transform: "translate(132.469 6.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5722",
    "data-name": "Path 5722",
    d: "M449.471,156.928a8.547,8.547,0,0,1-4.456,6.772c-2.462,1.267-4.456.29-4.456-2.191a8.547,8.547,0,0,1,4.456-6.772C447.477,153.469,449.471,154.465,449.471,156.928Z",
    transform: "translate(-440.56 -138.104)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5723",
    "data-name": "Path 5723",
    d: "M457.161,152.489a8.547,8.547,0,0,1-4.456,6.772c-2.462,1.267-4.456.29-4.456-2.191a8.546,8.546,0,0,1,4.456-6.772C455.167,149.031,457.161,150.009,457.161,152.489Z",
    transform: "translate(-432.604 -141.704)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5724",
    "data-name": "Path 5724",
    d: "M464.861,148.049a8.547,8.547,0,0,1-4.456,6.772c-2.462,1.267-4.456.29-4.456-2.191a8.546,8.546,0,0,1,4.456-6.772C462.867,144.591,464.861,145.569,464.861,148.049Z",
    transform: "translate(-424.638 -145.304)",
    fill: "#bdcefa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13628",
    "data-name": "Group 13628",
    transform: "translate(0 55.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5725",
    "data-name": "Path 5725",
    d: "M402.693,208.72a38.344,38.344,0,0,1-10.071,7.206c-9.135,4.69-17.172,2.1-17.172-8.981,0-11.534,8.138-25.729,20.569-32.121,9.684-4.979,16.622-1.7,16.622,7.8,0,8.257-4.517,15.771-10.458,18.831-2.584,1.322-4.456.942-4.74-1.919l-.1.054a16.289,16.289,0,0,1-7.1,8c-3.581,1.829-6.165.453-6.165-4.183,0-6.9,4.944-15.716,12.879-19.79a15.892,15.892,0,0,1,6.551-1.956l-1.648,11.317c-.549,3.621-.163,4.943,1.383,4.219,2.36-1.159,5.33-5.794,5.33-12.294,0-7.351-4.618-10.683-13.143-6.3-8.423,4.327-15.788,14.9-15.788,25.693,0,9.434,5.88,11.787,14.079,7.569a31.109,31.109,0,0,0,7.975-5.9ZM397.81,187.88a7.7,7.7,0,0,0-1.709.652c-3.622,1.865-6.49,7.007-6.49,11.371,0,2.155.936,3.024,2.747,2.1,2.034-1.05,4.191-4.8,4.679-8.347Z",
    transform: "translate(-375.45 -172.514)",
    fill: "#bdcefa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13629",
    "data-name": "Group 13629",
    transform: "translate(50.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5726",
    "data-name": "Path 5726",
    d: "M400.56,162.5l19.226,4.744a2.426,2.426,0,0,0,2.1-1.086l19.226-24.444Z",
    transform: "translate(-400.458 -141.71)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5727",
    "data-name": "Path 5727",
    d: "M414.264,157.48l-13.387,19.7a1.582,1.582,0,0,1-.366-1.068V154.13Z",
    transform: "translate(-400.51 -131.642)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5728",
    "data-name": "Path 5728",
    d: "M425.429,153.08l13.469,6.011a5.043,5.043,0,0,1-1.261.942L402.48,178.1a2.829,2.829,0,0,1-1.16.344l13.448-19.827,5.29,1.3Z",
    transform: "translate(-399.672 -132.493)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5729",
    "data-name": "Path 5729",
    d: "M427.471,142.56v22a3.767,3.767,0,0,1-.326,1.34l-13.306-5.957Z",
    transform: "translate(-386.72 -141.021)",
    fill: "#bdcefa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13633",
    "data-name": "Group 13633",
    transform: "translate(45.92 19.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5730",
    "data-name": "Path 5730",
    d: "M553.263,197.58a.305.305,0,0,1-.326-.29V112.244l-130.089,66.94a.356.356,0,0,1-.448-.109.279.279,0,0,1,.122-.4L553.588,111.23v86.042A.334.334,0,0,1,553.263,197.58Z",
    transform: "translate(-289.565 -111.23)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13632",
    "data-name": "Group 13632",
    transform: "translate(0 49.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13631",
    "data-name": "Group 13631",
    transform: "translate(81.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5731",
    "data-name": "Path 5731",
    d: "M491.311,159.637a.6.6,0,0,1-.651-.543v-.054a.655.655,0,0,1,1.3,0A.651.651,0,0,1,491.311,159.637Z",
    transform: "translate(-300.023 -122.661)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5732",
    "data-name": "Path 5732",
    d: "M491.311,169.239c-.366,0-.651-.2-.651-.525v-.109a.655.655,0,0,1,1.3,0A.668.668,0,0,1,491.311,169.239Zm0-4.49c-.366,0-.651-.2-.651-.525v-.109a.655.655,0,0,1,1.3,0A.668.668,0,0,1,491.311,164.749Zm0-4.472c-.366,0-.651-.2-.651-.525v-.109a.655.655,0,0,1,1.3,0A.682.682,0,0,1,491.311,160.277Zm0-4.49c-.366,0-.651-.2-.651-.525v-.109a.655.655,0,0,1,1.3,0A.668.668,0,0,1,491.311,155.786Zm0-4.472c-.366,0-.651-.2-.651-.525v-.109a.655.655,0,0,1,1.3,0A.682.682,0,0,1,491.311,151.314Zm0-4.49c-.366,0-.651-.2-.651-.525v-.109a.655.655,0,0,1,1.3,0A.668.668,0,0,1,491.311,146.824Zm0-4.49c-.366,0-.651-.2-.651-.525V141.7a.655.655,0,0,1,1.3,0A.668.668,0,0,1,491.311,142.333Z",
    transform: "translate(-300.023 -136.718)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5733",
    "data-name": "Path 5733",
    d: "M491.337,139.85a.718.718,0,0,1-.549-.235.255.255,0,0,1-.061-.072.532.532,0,0,1,.224-.779.792.792,0,0,1,.671,0,.565.565,0,0,1,.346.489A.618.618,0,0,1,491.337,139.85Z",
    transform: "translate(-300.049 -138.689)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5734",
    "data-name": "Path 5734",
    d: "M399.873,231.214a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.536.536,0,0,1,399.873,231.214Zm4.659-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.629.629,0,0,1,404.533,228.9Zm4.639-2.3a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8.734.734,0,0,1,.936.2.5.5,0,0,1-.183.76l-.122.054A.739.739,0,0,1,409.171,226.6Zm4.659-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.629.629,0,0,1,413.83,224.28Zm4.639-2.3a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.739.739,0,0,1,418.469,221.98Zm4.659-2.318a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8.734.734,0,0,1,.936.2.5.5,0,0,1-.183.76l-.122.054A.63.63,0,0,1,423.128,219.663Zm4.639-2.318a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8.734.734,0,0,1,.936.2.5.5,0,0,1-.183.76l-.122.054A.536.536,0,0,1,427.767,217.345Zm4.659-2.3a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.629.629,0,0,1,432.426,215.045Zm4.639-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.536.536,0,0,1,437.065,212.728Zm4.659-2.3a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779.734.734,0,0,1,.936.2.5.5,0,0,1-.2.76l-.122.054A1.3,1.3,0,0,1,441.724,210.428Zm4.639-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779.773.773,0,0,1,.936.2.5.5,0,0,1-.2.76l-.122.054A.594.594,0,0,1,446.363,208.111Zm4.659-2.3a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779.75.75,0,0,1,.936.2.5.5,0,0,1-.2.76l-.122.054A1.3,1.3,0,0,1,451.022,205.811Zm4.639-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779.734.734,0,0,1,.936.2.5.5,0,0,1-.2.76l-.122.054A.594.594,0,0,1,455.661,203.493Zm4.659-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779.734.734,0,0,1,.936.2.5.5,0,0,1-.2.76l-.122.054A.653.653,0,0,1,460.32,201.176Zm4.639-2.3a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779.75.75,0,0,1,.936.2.5.5,0,0,1-.2.76l-.122.054A.594.594,0,0,1,464.958,198.876Zm4.659-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.58.58,0,0,1,469.618,196.559Zm4.639-2.3a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8.734.734,0,0,1,.936.2.5.5,0,0,1-.183.76l-.122.054A.74.74,0,0,1,474.256,194.259Zm4.659-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.58.58,0,0,1,478.915,191.941Zm4.639-2.3a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.739.739,0,0,1,483.554,189.642Zm4.659-2.318a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8.734.734,0,0,1,.936.2.5.5,0,0,1-.183.76l-.122.054A.58.58,0,0,1,488.213,187.324Zm4.659-2.318a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8.734.734,0,0,1,.936.2.5.5,0,0,1-.183.76l-.122.054A.629.629,0,0,1,492.872,185.007Zm4.639-2.3a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.58.58,0,0,1,497.511,182.707Zm4.659-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.629.629,0,0,1,502.17,180.39Zm4.639-2.3a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8.734.734,0,0,1,.936.2.5.5,0,0,1-.183.76l-.122.054A.828.828,0,0,1,506.809,178.09Zm4.659-2.318a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8.734.734,0,0,1,.936.2.5.5,0,0,1-.183.76l-.122.054A.63.63,0,0,1,511.468,175.772Zm4.639-2.3a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.829.829,0,0,1,516.107,173.473Zm4.659-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.63.63,0,0,1,520.766,171.155Zm4.639-2.318a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8.734.734,0,0,1,.936.2.5.5,0,0,1-.183.76l-.122.054A.58.58,0,0,1,525.4,168.838Zm4.659-2.3a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8.734.734,0,0,1,.936.2.5.5,0,0,1-.183.76l-.122.054A.629.629,0,0,1,530.064,166.538Zm4.639-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779.734.734,0,0,1,.936.2.5.5,0,0,1-.2.76l-.122.054A.651.651,0,0,1,534.7,164.22Zm4.659-2.3a.667.667,0,0,1-.57-.308.542.542,0,0,1,.265-.779l.122-.054a.685.685,0,0,1,.875.235.542.542,0,0,1-.264.779l-.122.054A.937.937,0,0,1,539.362,161.921ZM544,159.6a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779.734.734,0,0,1,.936.2.5.5,0,0,1-.2.76l-.122.054A.651.651,0,0,1,544,159.6Zm4.659-2.3a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779.734.734,0,0,1,.936.2.5.5,0,0,1-.2.76l-.122.054A1.3,1.3,0,0,1,548.66,157.3Zm4.639-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779.734.734,0,0,1,.936.2.5.5,0,0,1-.2.76l-.122.054A.593.593,0,0,1,553.3,154.986Zm4.659-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779.734.734,0,0,1,.936.2.5.5,0,0,1-.2.76l-.122.054A.717.717,0,0,1,557.957,152.668Zm4.639-2.3a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.679.679,0,0,1,.875.217.535.535,0,0,1-.244.779l-.122.054A.536.536,0,0,1,562.6,150.369Zm4.659-2.318a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8.734.734,0,0,1,.936.2.5.5,0,0,1-.183.76l-.122.054A.629.629,0,0,1,567.255,148.051Zm4.639-2.3a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8.734.734,0,0,1,.936.2.5.5,0,0,1-.183.76l-.122.054A.738.738,0,0,1,571.894,145.752Zm4.659-2.318a.7.7,0,0,1-.57-.29.535.535,0,0,1,.244-.779l.122-.054a.711.711,0,0,1,.9.217.535.535,0,0,1-.244.779l-.122.054A.769.769,0,0,1,576.553,143.434Zm4.639-2.3a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8.734.734,0,0,1,.936.2.5.5,0,0,1-.183.76l-.122.054A.739.739,0,0,1,581.192,141.135Z",
    transform: "translate(-394.624 -137.656)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5735",
    "data-name": "Path 5735",
    d: "M397.611,192.161a.6.6,0,0,1-.651-.543.652.652,0,0,1,.326-.561.734.734,0,0,1,.916.2.514.514,0,0,1-.142.724A.552.552,0,0,1,397.611,192.161Z",
    transform: "translate(-396.96 -96.303)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5736",
    "data-name": "Path 5736",
    d: "M397.611,224.441a.61.61,0,0,1-.651-.579v-.127a.655.655,0,0,1,1.3,0v.127A.622.622,0,0,1,397.611,224.441Zm0-4.925a.61.61,0,0,1-.651-.579v-.127a.655.655,0,0,1,1.3,0v.127A.61.61,0,0,1,397.611,219.516Zm0-4.907a.61.61,0,0,1-.651-.579V213.9a.655.655,0,0,1,1.3,0v.127A.622.622,0,0,1,397.611,214.609Zm0-4.925a.61.61,0,0,1-.651-.579v-.127a.655.655,0,0,1,1.3,0v.127A.61.61,0,0,1,397.611,209.684Zm0-4.907a.61.61,0,0,1-.651-.579v-.127a.655.655,0,0,1,1.3,0v.127A.622.622,0,0,1,397.611,204.777Zm0-4.925a.61.61,0,0,1-.651-.579v-.127a.655.655,0,0,1,1.3,0v.127A.61.61,0,0,1,397.611,199.852Zm0-4.907a.61.61,0,0,1-.651-.579v-.127a.655.655,0,0,1,1.3,0v.127A.622.622,0,0,1,397.611,194.946Z",
    transform: "translate(-396.96 -94.126)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5737",
    "data-name": "Path 5737",
    d: "M397.611,213.875a.61.61,0,0,1-.651-.579.639.639,0,0,1,.651-.616.6.6,0,0,1,.651.543v.054A.624.624,0,0,1,397.611,213.875Z",
    transform: "translate(-396.96 -78.708)",
    fill: "#bdcefa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5738",
    "data-name": "Path 5738",
    d: "M357.415,253.285a.305.305,0,0,1-.325-.29V206.751l.163-.091,30.518-14.377a.355.355,0,0,1,.448.127.286.286,0,0,1-.142.4l-30.355,14.3v45.9C357.741,253.14,357.6,253.285,357.415,253.285Z",
    transform: "translate(-357.09 -95.267)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5739",
    "data-name": "Path 5739",
    d: "M368.371,358.2c-.366,0-.651-.2-.651-.525v-.109a.656.656,0,0,1,1.3,0A.668.668,0,0,1,368.371,358.2Zm0-4.69a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,353.512Zm0-4.8c-.366,0-.651-.2-.651-.525v-.109a.656.656,0,0,1,1.3,0A.668.668,0,0,1,368.371,348.713Zm0-4.69a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,344.024Zm0-4.8c-.366,0-.651-.2-.651-.525v-.109a.656.656,0,0,1,1.3,0A.668.668,0,0,1,368.371,339.226Zm0-4.744c-.366,0-.651-.2-.651-.525v-.109a.656.656,0,0,1,1.3,0A.668.668,0,0,1,368.371,334.482Zm0-4.69a.61.61,0,0,1-.651-.579V329.1a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,329.792Zm0-4.8c-.366,0-.651-.2-.651-.525v-.109a.656.656,0,0,1,1.3,0A.669.669,0,0,1,368.371,324.994Zm0-4.69a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,320.3Zm0-4.8c-.366,0-.651-.2-.651-.525v-.109a.656.656,0,0,1,1.3,0A.669.669,0,0,1,368.371,315.506Zm0-4.69a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,310.817Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,306.073Zm0-4.8c-.366,0-.651-.2-.651-.525v-.109a.656.656,0,0,1,1.3,0A.682.682,0,0,1,368.371,301.274Zm0-4.69a.61.61,0,0,1-.651-.579V295.9a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,296.585Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,291.841Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,287.1Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,282.353Zm0-4.8c-.366,0-.651-.2-.651-.525v-.109a.656.656,0,0,1,1.3,0A.682.682,0,0,1,368.371,277.555Zm0-4.69a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,272.865Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,268.121Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,263.378Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,258.634Zm0-4.8c-.366,0-.651-.2-.651-.525V253.2a.656.656,0,0,1,1.3,0A.682.682,0,0,1,368.371,253.835Zm0-4.69a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.636.636,0,0,1,368.371,249.146Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.636.636,0,0,1,368.371,244.4Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.636.636,0,0,1,368.371,239.658Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.636.636,0,0,1,368.371,234.914Zm0-4.816c-.366,0-.651-.2-.651-.525v-.109a.656.656,0,0,1,1.3,0A.669.669,0,0,1,368.371,230.1Zm0-4.671a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.636.636,0,0,1,368.371,225.426Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.636.636,0,0,1,368.371,220.682Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.636.636,0,0,1,368.371,215.938Zm0-4.762a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,211.176Zm0-4.8c-.366,0-.651-.2-.651-.525v-.109a.656.656,0,0,1,1.3,0A.668.668,0,0,1,368.371,206.378Zm0-4.69a.61.61,0,0,1-.651-.579V201a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,201.689Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,196.945Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,192.2Zm0-4.744a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.623.623,0,0,1,368.371,187.457Zm2.5-3.44a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8l.122-.054a.691.691,0,0,1,.9.217.557.557,0,0,1-.244.8l-.122.054A.656.656,0,0,1,370.874,184.017Zm4.7-2.408a.654.654,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.712.712,0,0,1,.9.217.557.557,0,0,1-.244.8A.975.975,0,0,1,375.573,181.609Zm4.639-2.336a.654.654,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.712.712,0,0,1,.9.217.557.557,0,0,1-.244.8A1.622,1.622,0,0,1,380.212,179.273Zm4.557-2.318a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8l.122-.054a.691.691,0,0,1,.9.217.543.543,0,0,1-.244.8l-.122.054A.709.709,0,0,1,384.77,176.955Zm4.7-2.39a.654.654,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.712.712,0,0,1,.9.217.557.557,0,0,1-.244.8A1.621,1.621,0,0,1,389.469,174.565Zm4.639-2.354a.654.654,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.712.712,0,0,1,.9.217.557.557,0,0,1-.244.8A1.045,1.045,0,0,1,394.108,172.211Zm4.557-2.3a.7.7,0,0,1-.57-.29.543.543,0,0,1,.244-.8l.122-.054a.691.691,0,0,1,.9.217.557.557,0,0,1-.244.8l-.122.054A.708.708,0,0,1,398.665,169.912Zm4.7-2.408a.655.655,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.712.712,0,0,1,.9.217.557.557,0,0,1-.244.8A1.045,1.045,0,0,1,403.365,167.5Zm4.618-2.336a.654.654,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.712.712,0,0,1,.9.217.557.557,0,0,1-.244.8A1.317,1.317,0,0,1,407.984,165.168Zm4.578-2.318a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8l.122-.054a.712.712,0,0,1,.9.217.543.543,0,0,1-.244.8l-.122.054A.768.768,0,0,1,412.561,162.85Zm4.7-2.39a.655.655,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.712.712,0,0,1,.9.217.557.557,0,0,1-.244.8A1.623,1.623,0,0,1,417.261,160.46Zm4.618-2.354a.655.655,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.712.712,0,0,1,.9.217.557.557,0,0,1-.244.8A.976.976,0,0,1,421.88,158.106Zm4.557-2.3a.7.7,0,0,1-.57-.29.543.543,0,0,1,.244-.8l.122-.054a.691.691,0,0,1,.9.217.543.543,0,0,1-.244.8l-.122.054A.656.656,0,0,1,426.437,155.807Z",
    transform: "translate(-346.093 -125.802)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5740",
    "data-name": "Path 5740",
    d: "M415.047,186.14a.654.654,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.691.691,0,0,1,.9.217.543.543,0,0,1-.244.8A1.046,1.046,0,0,1,415.047,186.14Zm-2.136-1.394a.611.611,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.61.61,0,0,1,412.911,184.746Zm6.755-.978a.655.655,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.691.691,0,0,1,.9.217.543.543,0,0,1-.244.8A1.045,1.045,0,0,1,419.666,183.768Zm4.6-2.372a.654.654,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.691.691,0,0,1,.9.217.543.543,0,0,1-.244.8A1.318,1.318,0,0,1,424.264,181.4ZM412.911,180a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.61.61,0,0,1,412.911,180Zm15.971-.978a.655.655,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.691.691,0,0,1,.9.217.543.543,0,0,1-.244.8A1.318,1.318,0,0,1,428.882,179.024Zm4.557-2.336a.7.7,0,0,1-.57-.29.543.543,0,0,1,.244-.8l.122-.054a.691.691,0,0,1,.9.217.543.543,0,0,1-.244.8l-.122.054A.708.708,0,0,1,433.44,176.689Zm-20.529-1.43a.61.61,0,0,1-.651-.579.654.654,0,0,1,.651-.634c.366,0,.651.2.651.525v.109A.61.61,0,0,1,412.911,175.258Zm25.208-1a.654.654,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.691.691,0,0,1,.9.217.543.543,0,0,1-.244.8A.976.976,0,0,1,438.119,174.262Zm4.618-2.372a.654.654,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.691.691,0,0,1,.9.217.543.543,0,0,1-.244.8A1.045,1.045,0,0,1,442.737,171.89Zm-29.826-1.376a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.61.61,0,0,1,412.911,170.514Zm34.363-.942a.7.7,0,0,1-.57-.29.543.543,0,0,1,.244-.8l.122-.054a.691.691,0,0,1,.9.217.543.543,0,0,1-.244.8l-.122.054A.94.94,0,0,1,447.275,169.573Zm4.679-2.426a.654.654,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.692.692,0,0,1,.9.217.543.543,0,0,1-.244.8A1.318,1.318,0,0,1,451.954,167.146Zm-39.043-1.376a.61.61,0,0,1-.651-.579v-.109a.656.656,0,0,1,1.3,0v.109A.61.61,0,0,1,412.911,165.77Zm43.661-1a.654.654,0,0,1-.57-.272.5.5,0,0,1,.183-.761l.122-.054a.691.691,0,0,1,.9.217.543.543,0,0,1-.244.8A1.454,1.454,0,0,1,456.572,164.774Zm4.557-2.336a.7.7,0,0,1-.57-.29.557.557,0,0,1,.244-.8l.122-.054a.712.712,0,0,1,.9.217.543.543,0,0,1-.244.8l-.122.054A.708.708,0,0,1,461.13,162.439Zm4.679-2.426a.655.655,0,0,1-.57-.272.5.5,0,0,1,.183-.76l.122-.054a.691.691,0,0,1,.9.217.543.543,0,0,1-.244.8A1.045,1.045,0,0,1,465.809,160.012Z",
    transform: "translate(-300.014 -122.349)",
    fill: "#bdcefa"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13641",
    "data-name": "Group 13641",
    transform: "translate(372.952 44.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13636",
    "data-name": "Group 13636",
    transform: "translate(2.874 30.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5741",
    "data-name": "Path 5741",
    d: "M628.472,173.457l-47.2,24.245c-3.438,1.774-9.5,1.539-13.489-.489l-45.248-23.249c-3.967-2.046-4.415-5.16-.977-6.935l47.2-24.245c3.438-1.774,9.5-1.539,13.489.489L627.5,166.522C631.463,168.568,631.911,171.683,628.472,173.457Z",
    transform: "translate(-519.242 -141.59)",
    fill: "#e8f2fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13635",
    "data-name": "Group 13635",
    transform: "translate(0.035 28.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5742",
    "data-name": "Path 5742",
    d: "M602.376,309.327V157.83h0a3.9,3.9,0,0,1-2.258,2.444l-47.2,24.245a13.462,13.462,0,0,1-6.266,1.177V338.261a13.514,13.514,0,0,0,6.266-1.177l47.2-24.245C601.908,311.934,602.641,310.649,602.376,309.327Z",
    transform: "translate(-490.923 -157.414)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5743",
    "data-name": "Path 5743",
    d: "M567.784,184.235l-45.248-23.249c-1.892-.978-2.971-2.191-3.215-3.386V309.1c-.346,1.521.753,3.2,3.215,4.472l45.248,23.249a16.879,16.879,0,0,0,7.223,1.666V185.919A17.436,17.436,0,0,1,567.784,184.235Z",
    transform: "translate(-519.259 -157.6)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5744",
    "data-name": "Path 5744",
    d: "M567.784,184.235l-45.248-23.249c-1.892-.978-2.971-2.191-3.215-3.386V309.1c-.346,1.521.753,3.2,3.215,4.472l45.248,23.249a16.879,16.879,0,0,0,7.223,1.666V185.919A17.436,17.436,0,0,1,567.784,184.235Z",
    transform: "translate(-519.259 -157.6)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13640",
    "data-name": "Group 13640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13638",
    "data-name": "Group 13638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5745",
    "data-name": "Path 5745",
    d: "M615.692,198.212c0,8.6-5.107,13.344-12.39,12.729a10.234,10.234,0,0,1-5.595-1.286l-60.3-30.98a13.569,13.569,0,0,1-1.485-.869c-10.152-6.265-18.087-19.157-18.087-29.876,0-10.429,7.528-15.191,17.294-11.588,1.465-7.406,8.423-10.031,16.785-5.722a30.271,30.271,0,0,1,7.752,5.885c4.435-3.35,11.231-3.476,18.82.435,11.414,5.867,21,18.921,23.54,31.161,3.459,2.209,6.165,6.573,6.266,10.284C612.8,184.487,615.692,191.748,615.692,198.212Z",
    transform: "translate(-517.83 -121.909)",
    fill: "#0080e9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13637",
    "data-name": "Group 13637",
    transform: "translate(6.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5746",
    "data-name": "Path 5746",
    d: "M618.172,174.71c-.1-3.712-2.787-8.057-6.266-10.284-2.543-12.24-12.105-25.295-23.54-31.161-6.694-3.44-12.736-3.748-17.131-1.5l-1.851.942a29.912,29.912,0,0,0-7.609-5.758c-4.74-2.426-9.013-2.644-12.105-1.032l-10.987,5.595a11.561,11.561,0,0,0-4.883,1.068l-12.919,6.573c2.97-1.376,6.8-1.394,11.047.163,1.465-7.406,8.423-10.031,16.785-5.722a30.276,30.276,0,0,1,7.752,5.885c4.435-3.35,11.231-3.476,18.819.435,11.414,5.867,21,18.921,23.54,31.161,3.459,2.209,6.165,6.573,6.266,10.284,4.517,6.12,7.406,13.363,7.406,19.827,0,5.848-2.38,9.922-6.185,11.733l12.919-6.573c3.886-1.774,6.307-5.867,6.307-11.787C625.578,188.073,622.689,180.812,618.172,174.71Z",
    transform: "translate(-520.88 -124.879)",
    fill: "#52a1f6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13639",
    "data-name": "Group 13639",
    transform: "translate(20.02 42.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5747",
    "data-name": "Path 5747",
    d: "M535.116,154.781c0,2.118-1.668,2.969-3.723,1.919a7.224,7.224,0,0,1-3.723-5.74c0-2.118,1.668-2.969,3.723-1.919A7.2,7.2,0,0,1,535.116,154.781Z",
    transform: "translate(-527.67 -148.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5944",
    "data-name": "Path 5944",
    d: "M2.728,0c1.639.08,3.08,2.31,3.219,4.98S4.869,9.752,3.23,9.671.149,7.361.011,4.691,1.088-.078,2.728,0Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 10.342, 7.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5748",
    "data-name": "Path 5748",
    d: "M546.556,161.391c0,2.118-1.668,2.969-3.723,1.919a7.223,7.223,0,0,1-3.723-5.74c0-2.118,1.668-2.969,3.723-1.919A7.2,7.2,0,0,1,546.556,161.391Z",
    transform: "translate(-515.835 -143.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5749",
    "data-name": "Path 5749",
    d: "M552.286,164.691c0,2.118-1.668,2.969-3.723,1.919a7.224,7.224,0,0,1-3.723-5.74c0-2.118,1.668-2.969,3.723-1.919A7.2,7.2,0,0,1,552.286,164.691Z",
    transform: "translate(-509.907 -140.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5750",
    "data-name": "Path 5750",
    d: "M558.007,168c0,2.118-1.668,2.969-3.723,1.919a7.224,7.224,0,0,1-3.723-5.74c0-2.118,1.668-2.969,3.723-1.919A7.2,7.2,0,0,1,558.007,168Z",
    transform: "translate(-503.989 -137.875)",
    fill: "#fff"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13643",
    "data-name": "Group 13643",
    transform: "translate(351.764 342.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5751",
    "data-name": "Path 5751",
    d: "M641.25,315.185l-86.427,43.093c-3.825,1.974-10.58,1.72-14.995-.561L511.08,342.453c-4.415-2.263-4.9-5.74-1.078-7.713L596.083,290.8c3.825-1.974,10.58-1.72,14.995.561l29.073,16.133C644.586,309.753,645.075,313.229,641.25,315.185Z",
    transform: "translate(-507.409 -289.466)",
    fill: "#e8f2fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13642",
    "data-name": "Group 13642",
    transform: "translate(0 23.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5752",
    "data-name": "Path 5752",
    d: "M623.188,309.7V302.17h0a4.382,4.382,0,0,1-2.5,2.734L534.258,348a15.054,15.054,0,0,1-6.958,1.3v8.745a15.055,15.055,0,0,0,6.958-1.3l86.427-43.093C622.679,312.6,623.493,311.169,623.188,309.7Z",
    transform: "translate(-486.844 -302.17)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5753",
    "data-name": "Path 5753",
    d: "M539.815,335.68l-28.748-15.264c-2.116-1.086-3.316-2.444-3.581-3.766v7.532c-.387,1.684.834,3.567,3.581,4.979l28.748,15.264a19.19,19.19,0,0,0,8.036,1.865v-8.745A18.991,18.991,0,0,1,539.815,335.68Z",
    transform: "translate(-507.416 -290.432)",
    fill: "url(#linear-gradient-8)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13645",
    "data-name": "Group 13645",
    transform: "translate(387.748 389.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5754",
    "data-name": "Path 5754",
    d: "M658.93,341.365,572.5,384.458c-3.825,1.974-10.58,1.72-14.995-.561L528.76,368.633c-4.415-2.263-4.9-5.74-1.078-7.713l86.1-43.944c3.825-1.974,10.58-1.72,14.995.561l29.074,16.133C662.287,335.933,662.775,339.391,658.93,341.365Z",
    transform: "translate(-525.103 -315.646)",
    fill: "#e8f2fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13644",
    "data-name": "Group 13644",
    transform: "translate(0.006 23.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5755",
    "data-name": "Path 5755",
    d: "M640.878,335.882V328.35h0a4.383,4.383,0,0,1-2.5,2.734l-86.427,43.094a15.056,15.056,0,0,1-6.958,1.3v8.745a15.055,15.055,0,0,0,6.958-1.3l86.427-43.094C640.369,338.779,641.183,337.331,640.878,335.882Z",
    transform: "translate(-504.534 -328.35)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5756",
    "data-name": "Path 5756",
    d: "M557.5,361.86,528.756,346.6c-2.116-1.086-3.316-2.444-3.581-3.766v7.532c-.387,1.684.834,3.567,3.581,4.979L557.5,370.605a19.19,19.19,0,0,0,8.036,1.865v-8.745A19.191,19.191,0,0,1,557.5,361.86Z",
    transform: "translate(-525.106 -316.612)",
    fill: "url(#linear-gradient-10)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13667",
    "data-name": "Group 13667",
    transform: "translate(37.209 185.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13647",
    "data-name": "Group 13647",
    transform: "translate(0 0.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5757",
    "data-name": "Path 5757",
    d: "M821.9,310.411,565.5,441.846c-11.556,5.939-31.922,5.178-45.268-1.666L363.859,360.131c-13.347-6.862-14.811-17.31-3.255-23.249L621.411,207.4c11.556-5.939,31.922-5.178,45.269,1.666l151.96,78.075C831.987,294.006,833.431,304.472,821.9,310.411Z",
    transform: "translate(-352.809 -203.399)",
    fill: "#e8f2fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13646",
    "data-name": "Group 13646",
    transform: "translate(0.032 98.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5758",
    "data-name": "Path 5758",
    d: "M732,264.243V257.96h0c-.712,3.1-3.215,5.993-7.569,8.22L468.037,397.616c-5.554,2.861-13.143,4.128-21.017,3.947v9.922c7.874.163,15.463-1.1,21.017-3.947L724.43,276.1C730.472,273.007,732.914,268.661,732,264.243Z",
    transform: "translate(-255.375 -257.96)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5759",
    "data-name": "Path 5759",
    d: "M520.238,375.108,363.863,295.059c-6.368-3.277-9.99-7.369-10.824-11.389v6.283c-1.18,5.106,2.523,10.755,10.824,15.028L520.238,385.03c6.938,3.567,15.747,5.432,24.252,5.613v-9.922C535.965,380.54,527.155,378.675,520.238,375.108Z",
    transform: "translate(-352.825 -237.118)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5760",
    "data-name": "Path 5760",
    d: "M520.238,375.108,363.863,295.059c-6.368-3.277-9.99-7.369-10.824-11.389v6.283c-1.18,5.106,2.523,10.755,10.824,15.028L520.238,385.03c6.938,3.567,15.747,5.432,24.252,5.613v-9.922C535.965,380.54,527.155,378.675,520.238,375.108Z",
    transform: "translate(-352.825 -237.118)",
    fill: "url(#linear-gradient-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13656",
    "data-name": "Group 13656",
    transform: "translate(38.537 110.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13648",
    "data-name": "Group 13648"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5761",
    "data-name": "Path 5761",
    d: "M561.471,333.854l-53.529,27.5L371.75,291.3l53.529-27.5Z",
    transform: "translate(-371.75 -263.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5762",
    "data-name": "Path 5762",
    d: "M492.219,302.49v19.772l-53.529,27.5V329.994Z",
    transform: "translate(-302.498 -232.436)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5763",
    "data-name": "Path 5763",
    d: "M371.75,278.99v19.772l136.192,70.054V349.044Z",
    transform: "translate(-371.75 -251.486)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13655",
    "data-name": "Group 13655",
    transform: "translate(24.18 5.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13650",
    "data-name": "Group 13650"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5764",
    "data-name": "Path 5764",
    d: "M438.008,282.619l-23.5,12.077a8.306,8.306,0,0,1-6.714-.254l-22.522-11.57c-1.974-1.014-2.2-2.571-.488-3.44l23.5-12.077a8.306,8.306,0,0,1,6.714.253l22.522,11.57C439.514,280.175,439.717,281.732,438.008,282.619Z",
    transform: "translate(-383.635 -266.762)",
    fill: "#9ce1f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13649",
    "data-name": "Group 13649",
    transform: "translate(0.017 14.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5765",
    "data-name": "Path 5765",
    d: "M425.011,284.048v-9.2h0a1.919,1.919,0,0,1-1.119,1.213l-23.5,12.077a6.646,6.646,0,0,1-3.113.579v9.741a6.88,6.88,0,0,0,3.113-.579l23.5-12.077C424.787,285.334,425.153,284.7,425.011,284.048Z",
    transform: "translate(-369.535 -274.633)",
    fill: "#39bed1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5766",
    "data-name": "Path 5766",
    d: "M407.807,287.984l-22.522-11.57a2.786,2.786,0,0,1-1.607-1.684v9.2c-.183.76.366,1.593,1.607,2.227l22.522,11.57a8.666,8.666,0,0,0,3.6.833v-9.741A8.59,8.59,0,0,1,407.807,287.984Z",
    transform: "translate(-383.643 -274.73)",
    fill: "#20a4af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13652",
    "data-name": "Group 13652",
    transform: "translate(41.44 21.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5767",
    "data-name": "Path 5767",
    d: "M458.378,294.409l-23.5,12.077a8.306,8.306,0,0,1-6.714-.253l-22.522-11.57c-1.973-1.014-2.2-2.571-.488-3.44l23.5-12.077a8.305,8.305,0,0,1,6.714.254l22.522,11.57C459.863,291.983,460.087,293.54,458.378,294.409Z",
    transform: "translate(-404.001 -278.552)",
    fill: "#ffb200"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13651",
    "data-name": "Group 13651",
    transform: "translate(0 14.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5768",
    "data-name": "Path 5768",
    d: "M445.381,295.838v-9.2h0a1.919,1.919,0,0,1-1.119,1.213l-23.5,12.077a6.646,6.646,0,0,1-3.113.579v9.741a6.88,6.88,0,0,0,3.113-.579l23.5-12.077C445.157,297.142,445.5,296.508,445.381,295.838Z",
    transform: "translate(-389.885 -286.423)",
    fill: "#d89200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5769",
    "data-name": "Path 5769",
    d: "M428.167,299.774,405.645,288.2a2.786,2.786,0,0,1-1.607-1.684v9.2c-.183.761.366,1.593,1.607,2.227l22.522,11.57a8.665,8.665,0,0,0,3.6.833v-9.741A8.463,8.463,0,0,1,428.167,299.774Z",
    transform: "translate(-404.003 -286.52)",
    fill: "#bc7b00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13654",
    "data-name": "Group 13654",
    transform: "translate(83.722 43.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5770",
    "data-name": "Path 5770",
    d: "M479.158,306.379l-23.5,12.077a8.306,8.306,0,0,1-6.714-.254l-22.522-11.57c-1.974-1.014-2.2-2.571-.488-3.44l23.5-12.077a8.306,8.306,0,0,1,6.714.254l22.522,11.57C480.664,303.935,480.888,305.492,479.158,306.379Z",
    transform: "translate(-424.785 -290.522)",
    fill: "#f4ff00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13653",
    "data-name": "Group 13653",
    transform: "translate(0.017 14.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5771",
    "data-name": "Path 5771",
    d: "M466.171,307.808v-9.2h0a1.919,1.919,0,0,1-1.119,1.213l-23.5,12.077a6.646,6.646,0,0,1-3.113.579v9.741a6.88,6.88,0,0,0,3.113-.579l23.5-12.077C465.927,309.112,466.293,308.46,466.171,307.808Z",
    transform: "translate(-410.675 -298.393)",
    fill: "#d2d600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5772",
    "data-name": "Path 5772",
    d: "M448.957,311.744l-22.522-11.57a2.786,2.786,0,0,1-1.607-1.684v9.2c-.183.76.366,1.593,1.607,2.227l22.522,11.57a8.664,8.664,0,0,0,3.6.833v-9.741A8.664,8.664,0,0,1,448.957,311.744Z",
    transform: "translate(-424.793 -298.49)",
    fill: "#939200"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13661",
    "data-name": "Group 13661",
    transform: "translate(386.545 31.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13658",
    "data-name": "Group 13658",
    transform: "translate(0 23.285)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18427",
    "data-name": "Ellipse 18427",
    cx: 36.215,
    cy: 18.613,
    rx: 36.215,
    ry: 18.613,
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13657",
    "data-name": "Group 13657",
    transform: "translate(0 18.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5773",
    "data-name": "Path 5773",
    d: "M604.63,256.645c-14.14,7.261-37.09,7.261-51.23,0-7.019-3.6-10.559-8.329-10.6-13.055V263.6c-.041,4.8,3.479,9.6,10.6,13.254,14.14,7.261,37.09,7.261,51.23,0,7.121-3.658,10.641-8.456,10.6-13.254V243.59C615.189,248.316,611.649,253.042,604.63,256.645Z",
    transform: "translate(-542.8 -243.59)",
    fill: "url(#linear-gradient-15)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13660",
    "data-name": "Group 13660",
    transform: "translate(5.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5774",
    "data-name": "Path 5774",
    d: "M576.47,242.9l22.115,11.371c-12.126,6.229-32.105,6.229-44.231,0s-12.126-16.5,0-22.724c6.775-3.476,16.3-5.178,25.818-4.6Z",
    transform: "translate(-545.26 -215.181)",
    fill: "#76b3ce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13659",
    "data-name": "Group 13659",
    transform: "translate(0 27.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5775",
    "data-name": "Path 5775",
    d: "M554.354,247.057c-6.042-3.1-9.074-7.206-9.094-11.317v11.443c-.02,4.146,3.011,8.293,9.094,11.425,12.126,6.229,32.105,6.229,44.231,0V247.057C586.46,253.285,566.48,253.285,554.354,247.057Z",
    transform: "translate(-545.26 -235.74)",
    fill: "#20a4af"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5776",
    "data-name": "Path 5776",
    d: "M576.47,242.9l22.115,11.371c-12.126,6.229-32.105,6.229-44.231,0s-12.126-16.5,0-22.724c6.775-3.476,16.3-5.178,25.818-4.6Z",
    transform: "translate(-545.26 -215.181)",
    fill: "#9ce1f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5777",
    "data-name": "Path 5777",
    d: "M560.6,236.352l3.7-15.952a47.626,47.626,0,0,1,18.413,4.6c12.126,6.229,12.126,16.5,0,22.724Z",
    transform: "translate(-529.39 -220.4)",
    fill: "#ffb200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5778",
    "data-name": "Path 5778",
    d: "M560.6,229.21v11.769l22.115,11.371V240.581Z",
    transform: "translate(-529.39 -213.258)",
    fill: "#bc7b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5779",
    "data-name": "Path 5779",
    d: "M580.564,252.366V229.28c-.061,4.092-3.093,8.166-9.094,11.244v23.321C577.594,260.695,580.625,256.53,580.564,252.366Z",
    transform: "translate(-518.145 -213.201)",
    fill: "#d89200"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13666",
    "data-name": "Group 13666",
    transform: "translate(292.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13664",
    "data-name": "Group 13664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13662",
    "data-name": "Group 13662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5780",
    "data-name": "Path 5780",
    d: "M552.264,244.523,500.77,218.069c-6.083-3.132-5.331-8.582,1.709-12.2h0c7.019-3.6,17.66-4,23.743-.869l51.494,26.454c6.083,3.132,5.33,8.582-1.709,12.2h0C568.968,247.257,558.347,247.655,552.264,244.523Z",
    transform: "translate(-496.66 -202.883)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13663",
    "data-name": "Group 13663",
    transform: "translate(0 10.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5781",
    "data-name": "Path 5781",
    d: "M575.987,239.124c-7.019,3.6-17.66,4-23.743.869L500.75,213.54c-2.645-1.358-3.988-3.169-4.09-5.07h0v13.616c.061,1.937,1.4,3.784,4.09,5.178l51.494,26.454c6.083,3.132,16.7,2.734,23.743-.869,3.967-2.046,5.941-4.671,5.8-7.134V232.1C581.867,234.543,579.893,237.114,575.987,239.124Z",
    transform: "translate(-496.66 -208.47)",
    fill: "url(#linear-gradient-16)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13665",
    "data-name": "Group 13665",
    transform: "translate(14.496 5.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5782",
    "data-name": "Path 5782",
    d: "M515.331,211.723a11.732,11.732,0,0,1-9.562,0c-2.645-1.358-2.645-3.549,0-4.907a11.732,11.732,0,0,1,9.562,0C517.976,208.174,517.976,210.365,515.331,211.723Z",
    transform: "translate(-503.785 -205.798)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5783",
    "data-name": "Path 5783",
    d: "M522.671,215.953a11.732,11.732,0,0,1-9.562,0c-2.645-1.358-2.645-3.549,0-4.907a11.732,11.732,0,0,1,9.562,0C525.316,212.4,525.316,214.595,522.671,215.953Z",
    transform: "translate(-496.191 -202.368)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5784",
    "data-name": "Path 5784",
    d: "M530,220.193a11.731,11.731,0,0,1-9.562,0c-2.645-1.358-2.645-3.549,0-4.907a11.732,11.732,0,0,1,9.562,0C532.646,216.626,532.646,218.835,530,220.193Z",
    transform: "translate(-488.608 -198.931)",
    fill: "#bdcefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5785",
    "data-name": "Path 5785",
    d: "M537.341,224.423a11.732,11.732,0,0,1-9.562,0c-2.645-1.358-2.645-3.549,0-4.907a11.732,11.732,0,0,1,9.562,0C539.966,220.874,539.966,223.065,537.341,224.423Z",
    transform: "translate(-481.015 -195.502)",
    fill: "#bdcefa"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13676",
    "data-name": "Group 13676",
    transform: "translate(348.995 159.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13668",
    "data-name": "Group 13668",
    transform: "translate(0 21.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5786",
    "data-name": "Path 5786",
    d: "M514.762,222.635h0a3.287,3.287,0,0,0,3.825-2.372l3.255-16.368a2.982,2.982,0,0,0-2.665-3.4h0a3.287,3.287,0,0,0-3.825,2.372L512.1,219.231A2.973,2.973,0,0,0,514.762,222.635Z",
    transform: "translate(-499.859 -200.444)",
    fill: "#f9bb83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5787",
    "data-name": "Path 5787",
    d: "M506.208,216.363h0a3.4,3.4,0,0,0,4.13,1.919l11.393-2.951a3.075,3.075,0,0,0,3.072-3.114h0a3.189,3.189,0,0,0-3.5-2.734l-12.94,3.2A2.889,2.889,0,0,0,506.208,216.363Z",
    transform: "translate(-506.055 -193.122)",
    fill: "#f9bb83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13671",
    "data-name": "Group 13671",
    transform: "translate(19.718 62.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13670",
    "data-name": "Group 13670",
    transform: "translate(0 25.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13669",
    "data-name": "Group 13669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5788",
    "data-name": "Path 5788",
    d: "M530.42,242.5c.041.4-.305.724-.9,1.05-.163.091.02-2.1-.55-1.738-.163.109-8.118,5.613-12.553,4.6a.856.856,0,0,1-.671-.851v-.887c-.061-1,1.607-2.535,4.15-4.726,2.808-2.426,4.6-3.947,8.769-1.793,1.2.616,1.668,1.068,1.689,1.467Z",
    transform: "translate(-515.743 -237.12)",
    fill: "#010400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5789",
    "data-name": "Path 5789",
    d: "M519.9,239.945c-3.377,2.933-5.229,4.671-3.5,5.559s5.208-.453,8.769-2.843c3.113-2.1,7.691-2.354,3.5-4.509C524.5,236,522.712,237.518,519.9,239.945Z",
    transform: "translate(-515.746 -237.12)",
    fill: "#484968"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5790",
    "data-name": "Path 5790",
    d: "M519.47,250.045l.244-27.105,10.071,2.9-1.729,4.418a29.213,29.213,0,0,1-1.282,11.878s-1.445,2.607-1.16,8.673C525.635,250.824,521.932,252.689,519.47,250.045Z",
    transform: "translate(-511.894 -222.94)",
    fill: "#f1bb85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13674",
    "data-name": "Group 13674",
    transform: "translate(9.999 55.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13673",
    "data-name": "Group 13673",
    transform: "translate(0 25.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13672",
    "data-name": "Group 13672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5791",
    "data-name": "Path 5791",
    d: "M525.64,238.586c.041.4-.305.724-.9,1.05-.163.091.02-2.1-.549-1.738-.163.109-8.118,5.613-12.553,4.6a.856.856,0,0,1-.671-.851v-.887c-.061-1,1.607-2.535,4.15-4.744,2.808-2.426,4.6-3.947,8.769-1.793,1.2.616,1.668,1.068,1.689,1.467Z",
    transform: "translate(-510.969 -233.19)",
    fill: "#010400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5792",
    "data-name": "Path 5792",
    d: "M515.134,236.025c-3.377,2.933-5.229,4.671-3.5,5.559s5.208-.453,8.769-2.843c3.113-2.1,7.691-2.354,3.5-4.509S517.942,233.6,515.134,236.025Z",
    transform: "translate(-510.962 -233.182)",
    fill: "#484968"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5793",
    "data-name": "Path 5793",
    d: "M514.69,246.115l.244-27.105,10.071,2.9-1.729,4.418a29.209,29.209,0,0,1-1.282,11.878s-1.444,2.607-1.159,8.673C520.854,246.894,517.152,248.777,514.69,246.115Z",
    transform: "translate(-507.12 -219.01)",
    fill: "#e29d66"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5794",
    "data-name": "Path 5794",
    d: "M539.294,223.777V233.79s-13.184,3.965-25.574-10.013V214.09Z",
    transform: "translate(-498.125 -167.639)",
    fill: "#9ce1f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5795",
    "data-name": "Path 5795",
    d: "M533.173,239.962a1.051,1.051,0,0,1-.427.127c-2.218.145-10.152-1.394-18.087-9.361a3.493,3.493,0,0,1-1.078-2.3V205.813a3.624,3.624,0,0,1,1.79-3.458l5.982-3.1a4.6,4.6,0,0,1,4.252.344l8.138,4.183c3.3,1.684,5.982,5.848,5.982,9.216v22.742a1.1,1.1,0,0,1-.57,1.086Z",
    transform: "translate(-498.27 -179.967)",
    fill: "#54a3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5796",
    "data-name": "Path 5796",
    d: "M526.364,205.568c.02.561-.407,1.123-1.241,1.557a7.279,7.279,0,0,1-5.961,0c-.834-.435-1.241-1-1.241-1.557v-4.925c-.02-.561.407-1.123,1.241-1.557a7.278,7.278,0,0,1,5.961,0c.834.435,1.241,1,1.241,1.557Z",
    transform: "translate(-493.78 -180.32)",
    fill: "#dda26f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5797",
    "data-name": "Path 5797",
    d: "M521.91,200.137c0,1.231.977,1.738,2.177,1.123a4.213,4.213,0,0,0,2.177-3.35c0-1.231-.977-1.738-2.177-1.123A4.193,4.193,0,0,0,521.91,200.137Z",
    transform: "translate(-489.652 -181.878)",
    fill: "#f9bb83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5798",
    "data-name": "Path 5798",
    d: "M519.7,217.142s-11.21-9.071-4.374-25.222l5.249,16.767Z",
    transform: "translate(-498.751 -185.611)",
    fill: "#3f4893"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18428",
    "data-name": "Ellipse 18428",
    cx: 11.597,
    cy: 10.321,
    rx: 11.597,
    ry: 10.321,
    transform: "translate(16.836 2.072)",
    fill: "#f1bb85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5799",
    "data-name": "Path 5799",
    d: "M522.728,219.967s8.626-8.456,2.645-24.136l-10.742,3.3s-3.7-8.148,8.443-10.5c0,0,8.1-1.575,10.926,4.382,0,0,6.511.471,4.049,12.385C538.048,205.409,537.7,216.689,522.728,219.967Z",
    transform: "translate(-497.733 -188.436)",
    fill: "#3f4893"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13675",
    "data-name": "Group 13675",
    transform: "translate(14.035 27.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5800",
    "data-name": "Path 5800",
    d: "M523.321,226.525h0a3.384,3.384,0,0,0,4.069-2.046l5.107-16.93a2.926,2.926,0,0,0-2.3-3.621h0a3.384,3.384,0,0,0-4.069,2.046l-5.107,16.93A2.926,2.926,0,0,0,523.321,226.525Z",
    transform: "translate(-504.731 -203.821)",
    fill: "#f9bb83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5801",
    "data-name": "Path 5801",
    d: "M513.028,219.533h0a3.34,3.34,0,0,0,3.906,2.263l15.361-2.77a3.171,3.171,0,0,0,3.4-2.843h0a3.116,3.116,0,0,0-3.194-3.024l-16.948,2.9A2.942,2.942,0,0,0,513.028,219.533Z",
    transform: "translate(-512.953 -196.25)",
    fill: "#f9bb83"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13684",
    "data-name": "Group 13684",
    transform: "translate(149.437 98.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13678",
    "data-name": "Group 13678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5802",
    "data-name": "Path 5802",
    d: "M410.53,334.9V233.573a7.093,7.093,0,0,1,4.049-6.229l136.843-70.308c5.392-2.77,12.126.688,12.126,6.229V264.589a7.093,7.093,0,0,1-4.049,6.229L422.656,341.126C417.264,343.878,410.53,340.42,410.53,334.9Z",
    transform: "translate(-405.322 -153.562)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5803",
    "data-name": "Path 5803",
    d: "M417.252,338.608c-2.584,0-5.392-1.829-5.392-4.8V232.486a4.751,4.751,0,0,1,2.686-4.146l136.843-70.308a5.766,5.766,0,0,1,2.665-.652c2.584,0,5.392,1.829,5.392,4.8V263.5a4.75,4.75,0,0,1-2.686,4.146L419.917,337.956A5.707,5.707,0,0,1,417.252,338.608Z",
    transform: "translate(-403.946 -152.493)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13677",
    "data-name": "Group 13677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5804",
    "data-name": "Path 5804",
    d: "M413.178,336.016V234.692a7.093,7.093,0,0,1,4.049-6.229l136.843-70.308a8.913,8.913,0,0,1,6.917-.489h0l-3.235-1.539a8.863,8.863,0,0,0-8.891-.471L412.019,225.964a7.093,7.093,0,0,0-4.049,6.229V333.517a6.923,6.923,0,0,0,3.337,5.812h0l.081.036a8.243,8.243,0,0,0,1.729.833l3.622,1.738A6.91,6.91,0,0,1,413.178,336.016Z",
    transform: "translate(-407.97 -154.681)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5805",
    "data-name": "Path 5805",
    d: "M413.01,258.51l.041.018h0C413.03,258.51,413.03,258.51,413.01,258.51Z",
    transform: "translate(-402.756 -70.512)",
    fill: "url(#linear-gradient-19)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13679",
    "data-name": "Group 13679",
    transform: "translate(13.286 116.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5806",
    "data-name": "Path 5806",
    d: "M418.546,302.626l98.594,50.662a8.94,8.94,0,0,0,8.077,0l136.843-70.307c5.392-2.77,5.392-9.687,0-12.457l-98.594-50.662a8.94,8.94,0,0,0-8.077,0L418.546,290.169C413.155,292.939,413.155,299.874,418.546,302.626Z",
    transform: "translate(-414.497 -218.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5807",
    "data-name": "Path 5807",
    d: "M662.063,257.225,525.22,327.532a8.94,8.94,0,0,1-8.077,0L418.549,276.87a7.024,7.024,0,0,1-4.049-6.229v6.573a6.988,6.988,0,0,0,4.049,6.229L517.143,334.1a8.94,8.94,0,0,0,8.077,0L662.063,263.8a6.964,6.964,0,0,0,4.008-5.9h0v-6.645A6.949,6.949,0,0,1,662.063,257.225Zm4.028-6.555v0Z",
    transform: "translate(-414.5 -193.141)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5808",
    "data-name": "Path 5808",
    d: "M600.173,256.571,482.658,316.957c-4.578,2.354-12.594,2.064-17.884-.652l-35.381-18.179c-5.29-2.716-5.86-6.826-1.282-9.2l117.515-60.385c4.578-2.354,12.594-2.064,17.884.652l35.381,18.179C604.182,250.107,604.751,254.218,600.173,256.571Z",
    transform: "translate(-403.616 -212.369)",
    fill: "#b8cff6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5809",
    "data-name": "Path 5809",
    d: "M428.109,290.38l117.515-60.385c4.578-2.354,12.594-2.064,17.884.652l35.381,18.179c2.523,1.3,3.967,2.915,4.293,4.49.468-2.01-1-4.255-4.293-5.939L563.508,229.2c-5.29-2.716-13.306-3.024-17.884-.652L428.109,288.931c-2.4,1.231-3.377,2.951-3.011,4.69A5.263,5.263,0,0,1,428.109,290.38Z",
    transform: "translate(-403.613 -212.372)",
    fill: "#99b5e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5810",
    "data-name": "Path 5810",
    d: "M513.052,251.253l-6.226-3.2-6.226,3.2,6.226,3.2ZM500.8,257.536l-6.226-3.2-6.226,3.2,6.226,3.2Zm24.5-12.584-6.226-3.2-6.226,3.2,6.226,3.2Zm35.584,3.35,12.98-6.663-6.226-3.2-12.98,6.663Zm2.441-12.077-6.226-3.2-6.226,3.2,6.226,3.2Zm-25.778,2.426-6.226-3.2-6.226,3.2,6.226,3.2Zm-49.012,25.186-6.226-3.2-6.226,3.2,6.226,3.2ZM552.522,246.2l-107.4,55.189,6.226,3.2,107.4-55.189ZM476.288,270.12l-6.226-3.2-6.226,3.2,6.226,3.2ZM547.6,237.909l-113,58.068,6.226,3.2,113-58.068Zm30.559,5.939-122.5,62.938,6.226,3.2,122.5-62.938ZM451.792,282.722l-6.226-3.2-6.226,3.2,6.226,3.2Zm12.248-6.3-6.226-3.2-6.226,3.2,6.226,3.2Z",
    transform: "translate(-393.706 -207.449)",
    fill: "#99b5e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5811",
    "data-name": "Path 5811",
    d: "M513.052,250.705l-6.226-3.2-6.226,3.2,6.226,3.2Zm-12.248,6.3-6.226-3.2-6.226,3.2,6.226,3.2Zm24.5-12.584-6.226-3.2-6.226,3.2,6.226,3.2Zm35.584,3.35,12.98-6.663-6.226-3.2-12.98,6.663Zm2.441-12.077-6.226-3.2-6.226,3.2,6.226,3.2Zm-25.778,2.426-6.226-3.2-6.226,3.2,6.226,3.2Zm-49.012,25.168-6.226-3.2-6.226,3.2,6.226,3.2Zm63.986-17.636-107.4,55.189,6.226,3.2,107.4-55.189ZM476.288,269.59l-6.226-3.2-6.226,3.2,6.226,3.2Zm71.311-32.23-113,58.068,6.226,3.2,113-58.068Zm30.559,5.939-122.5,62.938,6.226,3.2,122.5-62.938ZM451.792,282.174l-6.226-3.2-6.226,3.2,6.226,3.2Zm12.248-6.283-6.226-3.2-6.226,3.2,6.226,3.2Z",
    transform: "translate(-393.706 -207.879)",
    fill: "#e4f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5812",
    "data-name": "Path 5812",
    d: "M519.064,241.68l5.758,2.969.468-.235-6.226-3.2-6.226,3.2.468.235Zm12.248-6.283,5.758,2.969.468-.235-6.226-3.2-6.226,3.2.468.235ZM506.8,247.981l5.758,2.969.468-.235-6.226-3.2-6.226,3.2.468.235Zm48.32-3.187,12.512-6.428,5.758,2.969.468-.235-6.226-3.2-12.98,6.663Zm-60.568,9.488,5.758,2.969.468-.235-6.226-3.2-6.226,3.2.468.235Zm62.542-21.311,5.758,2.969.468-.235-6.226-3.2-6.226,3.2.468.235Zm21.058,10.321-122.5,62.938.468.235,122.032-62.7,5.758,2.969.468-.235Zm-24.781-2.5.468-.235-6.226-3.2-113,58.068.468.235,112.531-57.832ZM445.556,279.45l5.758,2.969.468-.235-6.226-3.2-6.226,3.2.468.235ZM558.27,249.086l.468-.235-6.226-3.2-107.4,55.189.468.235,106.915-54.935ZM457.8,273.167l5.758,2.969.468-.235-6.226-3.2-6.226,3.2.468.235Zm24.5-12.6,5.758,2.969.468-.235-6.226-3.2-6.226,3.2.468.235Zm-12.248,6.3,5.758,2.969.468-.235-6.226-3.2-6.226,3.2.468.235Z",
    transform: "translate(-393.695 -207.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5813",
    "data-name": "Path 5813",
    d: "M534.723,267.3,498.1,286.108c-2.279,1.159-6.287,1.014-8.911-.326l-8.036-4.128c-2.625-1.34-2.909-3.4-.631-4.581l36.622-18.813c2.279-1.159,6.287-1.014,8.911.326l8.036,4.128C536.717,264.054,537,266.118,534.723,267.3Z",
    transform: "translate(-347.789 -187.622)",
    fill: "#b8cff6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5814",
    "data-name": "Path 5814",
    d: "M480.507,278.036l36.622-18.813c2.279-1.159,6.287-1.014,8.911.326l8.036,4.128a3.746,3.746,0,0,1,2.075,2.119c.326-1.032-.366-2.209-2.075-3.078l-8.036-4.128c-2.625-1.34-6.633-1.5-8.911-.326l-36.622,18.813c-1.241.634-1.689,1.539-1.444,2.462A2.749,2.749,0,0,1,480.507,278.036Z",
    transform: "translate(-347.774 -187.626)",
    fill: "#99b5e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13683",
    "data-name": "Group 13683",
    transform: "translate(27.304 33.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13682",
    "data-name": "Group 13682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5815",
    "data-name": "Path 5815",
    d: "M530.207,180.262v-3.748c0-3.223-2.543-4.527-5.676-2.915l-97.455,50.083c-3.133,1.611-5.676,5.522-5.676,8.745v3.748Z",
    transform: "translate(-421.38 -172.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13680",
    "data-name": "Group 13680",
    transform: "translate(5.473 43.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5816",
    "data-name": "Path 5816",
    d: "M428.637,203a4.428,4.428,0,0,1-2.279,3.531c-1.261.652-2.279.127-2.279-1.177a4.428,4.428,0,0,1,2.279-3.531C427.62,201.172,428.637,201.715,428.637,203Z",
    transform: "translate(-424.08 -193.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5817",
    "data-name": "Path 5817",
    d: "M432.587,200.721a4.428,4.428,0,0,1-2.279,3.531c-1.261.652-2.279.127-2.279-1.177a4.428,4.428,0,0,1,2.279-3.531C431.57,198.892,432.587,199.435,432.587,200.721Z",
    transform: "translate(-419.994 -195.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5818",
    "data-name": "Path 5818",
    d: "M436.537,198.437a4.428,4.428,0,0,1-2.279,3.531c-1.261.652-2.279.127-2.279-1.177a4.428,4.428,0,0,1,2.279-3.531C435.5,196.627,436.537,197.152,436.537,198.437Z",
    transform: "translate(-415.907 -196.992)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5819",
    "data-name": "Path 5819",
    d: "M438.623,219.2l-17.232,8.854V214.114l17.232-8.854Z",
    transform: "translate(-421.39 -146.683)",
    fill: "#f4ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5820",
    "data-name": "Path 5820",
    d: "M449.2,213.092l-17.233,8.854V208L449.2,199.15Z",
    transform: "translate(-410.445 -151.636)",
    fill: "#ffb200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5821",
    "data-name": "Path 5821",
    d: "M459.783,206.982l-17.233,8.854V201.894l17.233-8.854Z",
    transform: "translate(-399.499 -156.589)",
    fill: "#9ce1f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5822",
    "data-name": "Path 5822",
    d: "M453.94,210.174l42.6-21.891V185.35l-42.6,21.891Z",
    transform: "translate(-387.716 -162.823)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5823",
    "data-name": "Path 5823",
    d: "M453.94,207.134l42.6-21.891V182.31L453.94,204.2Z",
    transform: "translate(-387.716 -165.287)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5824",
    "data-name": "Path 5824",
    d: "M453.94,204.076l42.6-21.873V179.27l-42.6,21.873Z",
    transform: "translate(-387.716 -167.751)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5825",
    "data-name": "Path 5825",
    d: "M526.474,216.227,425.134,268.3c-2.055,1.05-3.743-.072-3.743-2.517V249.036a7.781,7.781,0,0,1,3.743-6.355l101.341-52.074c2.055-1.05,3.744.072,3.744,2.517v16.749A7.833,7.833,0,0,1,526.474,216.227Z",
    transform: "translate(-421.39 -158.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13681",
    "data-name": "Group 13681",
    transform: "translate(31.23 49.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5826",
    "data-name": "Path 5826",
    d: "M450.005,226.218l-13.265,6.808V218.468l13.265-6.808Z",
    transform: "translate(-436.74 -191.344)",
    fill: "#f4ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5827",
    "data-name": "Path 5827",
    d: "M458.125,220.488,444.88,227.3V215.038l13.245-6.808Z",
    transform: "translate(-428.319 -194.125)",
    fill: "#9ce1f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5828",
    "data-name": "Path 5828",
    d: "M466.255,218.311,453.01,225.1V207.23l13.245-6.79Z",
    transform: "translate(-419.908 -200.44)",
    fill: "#ffb200"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5829",
    "data-name": "Path 5829",
    d: "M471.25,204.7l3.56-1.829V199.96l-3.56,1.811Z",
    transform: "translate(-369.808 -150.979)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5830",
    "data-name": "Path 5830",
    d: "M471.25,201.672l3.56-1.829V196.91l-3.56,1.829Z",
    transform: "translate(-369.808 -153.452)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5831",
    "data-name": "Path 5831",
    d: "M471.25,198.632l3.56-1.829V193.87l-3.56,1.829Z",
    transform: "translate(-369.808 -155.916)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5832",
    "data-name": "Path 5832",
    d: "M461.36,213.853l18.413-9.47V201.45l-18.413,9.47Z",
    transform: "translate(-380.039 -149.771)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5833",
    "data-name": "Path 5833",
    d: "M461.36,210.795l18.413-9.452V198.41l-18.413,9.452Z",
    transform: "translate(-380.039 -152.236)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5834",
    "data-name": "Path 5834",
    d: "M461.36,207.755l18.413-9.452V195.37l-18.413,9.452Z",
    transform: "translate(-380.039 -154.7)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5835",
    "data-name": "Path 5835",
    d: "M426.87,221.54l-3.54,1.829V226.3l3.54-1.829Z",
    transform: "translate(-419.383 -133.485)",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5836",
    "data-name": "Path 5836",
    d: "M426.87,224.58l-3.54,1.829v2.933l3.54-1.829Z",
    transform: "translate(-419.383 -131.021)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5837",
    "data-name": "Path 5837",
    d: "M426.87,227.62l-3.54,1.829v2.933l3.54-1.829Z",
    transform: "translate(-419.383 -128.557)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5838",
    "data-name": "Path 5838",
    d: "M444.333,215.83l-18.413,9.452v2.933l18.413-9.452Z",
    transform: "translate(-416.704 -138.114)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5839",
    "data-name": "Path 5839",
    d: "M444.333,218.87l-18.413,9.47v2.915l18.413-9.452Z",
    transform: "translate(-416.704 -135.65)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5840",
    "data-name": "Path 5840",
    d: "M444.333,221.91l-18.413,9.47v2.933l18.413-9.47Z",
    transform: "translate(-416.704 -133.185)",
    fill: "url(#linear-gradient-35)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5841",
    "data-name": "Path 5841",
    d: "M520.213,217.31l-92.673,47.62c-1.933,1-3.5-.072-3.5-2.354h0a7.241,7.241,0,0,1,3.5-5.939l92.673-47.62c1.933-1,3.5.072,3.5,2.354h0A7.241,7.241,0,0,1,520.213,217.31Z",
    transform: "translate(-418.648 -143.94)",
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13690",
    "data-name": "Group 13690",
    transform: "translate(88.848 82.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13686",
    "data-name": "Group 13686",
    transform: "translate(0 97.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5842",
    "data-name": "Path 5842",
    d: "M471.067,285.948l-87.933,45.176c-2.726,1.394-4.944-.109-4.944-3.332V253.809a10.335,10.335,0,0,1,4.944-8.42l87.933-45.176c2.726-1.394,4.944.109,4.944,3.332v73.983A10.261,10.261,0,0,1,471.067,285.948Z",
    transform: "translate(-378.19 -199.692)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13685",
    "data-name": "Group 13685",
    transform: "translate(7.67 28.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5843",
    "data-name": "Path 5843",
    d: "M464.461,245.613,381.96,288v-5.5l82.5-42.405Z",
    transform: "translate(-381.96 -195.939)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5844",
    "data-name": "Path 5844",
    d: "M440.726,231.918c0,14.485-11.414,32.085-25.513,39.327S389.7,272.622,389.7,258.137s11.414-32.085,25.513-39.327C429.292,211.567,440.726,217.433,440.726,231.918Z",
    transform: "translate(-373.953 -215.706)",
    fill: "url(#linear-gradient-38)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13689",
    "data-name": "Group 13689",
    transform: "translate(180.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5845",
    "data-name": "Path 5845",
    d: "M559.817,216.02,471.884,261.2c-2.726,1.394-4.944-.109-4.944-3.332V200.159a10.335,10.335,0,0,1,4.944-8.42l87.933-45.176c2.726-1.394,4.944.109,4.944,3.332V207.6A10.332,10.332,0,0,1,559.817,216.02Z",
    transform: "translate(-466.94 -146.042)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13688",
    "data-name": "Group 13688",
    transform: "translate(7.65 13.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5846",
    "data-name": "Path 5846",
    d: "M553.2,181.774,470.7,224.18v-5.522l82.5-42.387Z",
    transform: "translate(-470.7 -135.404)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5847",
    "data-name": "Path 5847",
    d: "M553.2,175.544l-82.5,42.387v-5.5l82.5-42.387Z",
    transform: "translate(-470.7 -140.454)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13687",
    "data-name": "Group 13687",
    transform: "translate(1.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5848",
    "data-name": "Path 5848",
    d: "M493.676,192.658,471.52,204.047V181.269l22.156-11.389Z",
    transform: "translate(-471.52 -140.584)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5849",
    "data-name": "Path 5849",
    d: "M507.686,184.568,485.53,195.957V173.179l22.156-11.389Z",
    transform: "translate(-457.026 -147.142)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5850",
    "data-name": "Path 5850",
    d: "M521.7,176.478,499.54,187.867V165.089L521.7,153.7Z",
    transform: "translate(-442.532 -153.7)",
    fill: "url(#linear-gradient-44)"
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13696",
    "data-name": "Group 13696",
    transform: "translate(5.722 330.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13692",
    "data-name": "Group 13692",
    transform: "translate(0 42.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5851",
    "data-name": "Path 5851",
    d: "M446.562,338.407l-47.2,24.245c-3.438,1.774-9.5,1.539-13.489-.489l-45.248-23.249c-3.967-2.046-4.415-5.16-.977-6.935l47.2-24.245c3.438-1.775,9.5-1.539,13.489.489l45.248,23.249C449.573,333.518,450,336.651,446.562,338.407Z",
    transform: "translate(-337.332 -306.54)",
    fill: "#e8f2fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13691",
    "data-name": "Group 13691",
    transform: "translate(0.035 28.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5852",
    "data-name": "Path 5852",
    d: "M420.466,399.226V322.78h0a3.9,3.9,0,0,1-2.258,2.444l-47.2,24.245a13.463,13.463,0,0,1-6.266,1.177V428.2a13.515,13.515,0,0,0,6.266-1.177l47.2-24.245C420,401.851,420.731,400.547,420.466,399.226Z",
    transform: "translate(-309.013 -322.364)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5853",
    "data-name": "Path 5853",
    d: "M385.874,349.185l-45.248-23.249c-1.892-.978-2.97-2.191-3.215-3.386V399c-.346,1.521.753,3.2,3.215,4.472l45.248,23.249a16.879,16.879,0,0,0,7.223,1.666V350.869A17.437,17.437,0,0,1,385.874,349.185Z",
    transform: "translate(-337.349 -322.55)",
    fill: "url(#linear-gradient-46)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13695",
    "data-name": "Group 13695",
    transform: "translate(0.666 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5945",
    "data-name": "Path 5945",
    d: "M23.1.019C36.993.7,49.208,19.654,50.387,42.354S41.263,82.906,27.374,82.225,1.271,62.59.092,39.89,9.216-.662,23.1.019Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 25.239)",
    fill: "#0079c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5946",
    "data-name": "Path 5946",
    d: "M20.815.017C33.327.63,44.33,17.7,45.392,38.142S37.172,74.66,24.66,74.047,1.145,56.365.083,35.922,8.3-.6,20.815.017Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 4.212, 27.528)",
    fill: "#0080e9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13693",
    "data-name": "Group 13693",
    transform: "translate(20.143 3.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5854",
    "data-name": "Path 5854",
    d: "M386.338,288.8c-8.789-4.509-16.744-4.925-22.482-1.937l-16.3,8.383h0c5.717-2.9,13.611-2.462,22.319,2.01,17.5,8.981,31.678,30.854,31.678,48.833,0,8.945-3.52,15.246-9.2,18.215h0l16.3-8.383c5.778-2.933,9.359-9.252,9.359-18.288C418.016,319.657,403.835,297.8,386.338,288.8Z",
    transform: "translate(-347.56 -284.954)",
    fill: "#52a1f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13694",
    "data-name": "Group 13694",
    transform: "translate(24.131 27.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5855",
    "data-name": "Path 5855",
    d: "M355.211,317.06a17.363,17.363,0,0,1,4.212.76c.163.036.285.09.427.127a21.8,21.8,0,0,1,2.665,1.032v-7.1L353.97,307.5A44.245,44.245,0,0,0,355.211,317.06Z",
    transform: "translate(-344.916 -290.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5856",
    "data-name": "Path 5856",
    d: "M364.734,310.032h.509c.1,0,.224-.018.366-.018a10.825,10.825,0,0,0,2.909-.6,37.5,37.5,0,0,0-7.528-8.257,29.516,29.516,0,0,1,2.421,4.907C363.9,307.316,364.347,308.656,364.734,310.032Z",
    transform: "translate(-337.654 -295.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5857",
    "data-name": "Path 5857",
    d: "M360.131,298.77c-1.567.018-3.031.978-4.232,2.806a13.335,13.335,0,0,0-1.119,2.155,35.156,35.156,0,0,0,4.049,3.495c.122.09.264.181.387.29a28.67,28.67,0,0,0,2.441,1.575v-9.633a1.518,1.518,0,0,1-.142-.072A13.219,13.219,0,0,0,360.131,298.77Z",
    transform: "translate(-344.078 -297.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5858",
    "data-name": "Path 5858",
    d: "M358.829,314.292a15.658,15.658,0,0,0-4.049-.652,33.762,33.762,0,0,0,1.119,3.3,21.6,21.6,0,0,0,4.232,7.134c.468.308.936.579,1.4.851a1.5,1.5,0,0,0,.142.072V315.36a21.521,21.521,0,0,0-2.441-.941C359.093,314.364,358.951,314.328,358.829,314.292Z",
    transform: "translate(-344.078 -285.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5859",
    "data-name": "Path 5859",
    d: "M359.443,305.723a37.7,37.7,0,0,1-4.212-3.6,28.581,28.581,0,0,0-1.261,8.329l8.545,4.382v-7.116a29.908,29.908,0,0,1-2.665-1.7A4.688,4.688,0,0,1,359.443,305.723Z",
    transform: "translate(-344.916 -294.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5860",
    "data-name": "Path 5860",
    d: "M358.777,303.784c-.224-.235-.448-.489-.671-.742-.122-.127-.244-.272-.366-.416a39.737,39.737,0,0,1-2.991-3.875c-3.215,1.72-5.046,5.142-5.208,9.777l7.914,4.074A28.711,28.711,0,0,1,358.777,303.784Z",
    transform: "translate(-349.499 -297.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5861",
    "data-name": "Path 5861",
    d: "M356.059,313.65a4.088,4.088,0,0,0-.468.036c-.122.018-.224.018-.346.036a10.7,10.7,0,0,0-2.686.706,37.764,37.764,0,0,0,7.141,7.677,29.522,29.522,0,0,1-2.421-4.907A35.317,35.317,0,0,1,356.059,313.65Z",
    transform: "translate(-346.375 -285.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5862",
    "data-name": "Path 5862",
    d: "M358.106,319.2c.224-.018.448-.054.671-.054A45.29,45.29,0,0,1,357.434,309l-7.914-4.074a31.055,31.055,0,0,0,5.188,15.083,11.038,11.038,0,0,1,3.011-.779A3.13,3.13,0,0,1,358.106,319.2Z",
    transform: "translate(-349.52 -292.562)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5863",
    "data-name": "Path 5863",
    d: "M355.591,302.681c.163.181.305.344.468.507a13.761,13.761,0,0,1,1.2-2.318,7.479,7.479,0,0,1,2.421-2.408,12.023,12.023,0,0,0-7.121.362,38.975,38.975,0,0,0,2.686,3.44A2.53,2.53,0,0,0,355.591,302.681Z",
    transform: "translate(-346.375 -298.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5864",
    "data-name": "Path 5864",
    d: "M363.02,321.516c.244.235.468.507.712.76.143.145.265.272.366.4a43.967,43.967,0,0,1,3.255,4c2.848-1.72,4.639-4.925,4.8-9.542l-7.914-4.074A29.085,29.085,0,0,1,363.02,321.516Z",
    transform: "translate(-335.554 -285.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5865",
    "data-name": "Path 5865",
    d: "M361.79,310.438a17.916,17.916,0,0,0,4.11.869,34.68,34.68,0,0,0-1.221-3.676,22.261,22.261,0,0,0-4.232-7.152c-.468-.308-.956-.6-1.424-.851l-.183-.109v9.669a23.071,23.071,0,0,0,2.523,1.086A2.611,2.611,0,0,0,361.79,310.438Z",
    transform: "translate(-339.878 -296.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5866",
    "data-name": "Path 5866",
    d: "M365.242,318.913c-.163-.181-.346-.362-.509-.543A13.954,13.954,0,0,1,363.411,321a7.479,7.479,0,0,1-2.421,2.408,11.869,11.869,0,0,0,7.548-.507,41.179,41.179,0,0,0-2.93-3.6C365.466,319.148,365.364,319.022,365.242,318.913Z",
    transform: "translate(-337.654 -281.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5867",
    "data-name": "Path 5867",
    d: "M364.1,307.19c-.122,0-.244.018-.366.018-.224,0-.468.018-.712,0a46.673,46.673,0,0,1,1.241,9.759l7.914,4.074a30.714,30.714,0,0,0-4.822-14.521A11.213,11.213,0,0,1,364.1,307.19Z",
    transform: "translate(-335.554 -291.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5868",
    "data-name": "Path 5868",
    d: "M366.286,307.883a18.625,18.625,0,0,1-4.313-.942c-.122-.036-.264-.091-.427-.145a29.141,29.141,0,0,1-2.706-1.177v7.08l8.626,4.436A44.248,44.248,0,0,0,366.286,307.883Z",
    transform: "translate(-339.878 -292.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5869",
    "data-name": "Path 5869",
    d: "M361.994,319.263a35.394,35.394,0,0,1,4.313,3.476,28.761,28.761,0,0,0,1.16-8L358.84,310.3v7.062a30.1,30.1,0,0,1,2.706,1.593C361.709,319.082,361.871,319.172,361.994,319.263Z",
    transform: "translate(-339.878 -288.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5870",
    "data-name": "Path 5870",
    d: "M365.9,320.1a34.489,34.489,0,0,0-4.13-3.368c-.122-.09-.265-.181-.407-.272a29.178,29.178,0,0,0-2.523-1.5v9.669s.142.072.183.09c.468.217.956.416,1.424.6,1.567-.018,3.031-.96,4.232-2.788A12.407,12.407,0,0,0,365.9,320.1Z",
    transform: "translate(-339.878 -284.431)",
    fill: "#fff"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13709",
    "data-name": "Group 13709",
    transform: "translate(399.905 286.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13700",
    "data-name": "Group 13700",
    transform: "translate(5.62 55.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13699",
    "data-name": "Group 13699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13698",
    "data-name": "Group 13698",
    transform: "translate(0 17.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13697",
    "data-name": "Group 13697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5871",
    "data-name": "Path 5871",
    d: "M534.43,300.41c-.407.163-.549.6-.59,1.213-.02.181,2.035-1.05,1.974-.416-.02.181-1.506,9.017,1.668,11.95a1.016,1.016,0,0,0,1.16.09l.875-.435c1.017-.453,1.668-2.481,2.584-5.522,1-3.35,1.607-5.486-2.543-7.659-1.18-.616-1.872-.76-2.258-.579Z",
    transform: "translate(-533.84 -298.976)",
    fill: "#010400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5872",
    "data-name": "Path 5872",
    d: "M540.68,307.274c-1.2,4.056-1.994,6.337-3.7,5.432-1.729-.905-2.116-4.255-1.526-8.166.509-3.44-1.465-7.08,2.686-4.907C542.267,301.806,541.677,303.925,540.68,307.274Z",
    transform: "translate(-532.44 -298.978)",
    fill: "#484968"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5873",
    "data-name": "Path 5873",
    d: "M566.724,289.25l-8.525,2.77-3.459,3.495a37.361,37.361,0,0,0-10.966,6.808s-1.831,2.39-7.894,5.142a4.455,4.455,0,0,0,3.784,4.382l24.292-12.439a5.409,5.409,0,0,0,3.032-4.146A22.113,22.113,0,0,0,566.724,289.25Z",
    transform: "translate(-531.73 -289.25)",
    fill: "#e29d66"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13703",
    "data-name": "Group 13703",
    transform: "translate(21.061 62.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13702",
    "data-name": "Group 13702",
    transform: "translate(1.626 25.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13701",
    "data-name": "Group 13701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5874",
    "data-name": "Path 5874",
    d: "M542.232,312.762c-.041.38.305.724.9,1.05.163.091-.02-2.1.549-1.738.163.109,8.077,5.595,12.512,4.581a.817.817,0,0,0,.651-.851v-.887c.061-1-1.607-2.517-4.151-4.726-2.787-2.426-4.578-3.929-8.748-1.793-1.2.616-1.668,1.068-1.668,1.467Z",
    transform: "translate(-542.229 -307.374)",
    fill: "#2b0d60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5875",
    "data-name": "Path 5875",
    d: "M552.682,310.2c3.377,2.933,5.208,4.653,3.479,5.541s-5.188-.453-8.749-2.843c-3.113-2.1-7.65-2.354-3.479-4.491S549.875,307.775,552.682,310.2Z",
    transform: "translate(-542.201 -307.366)",
    fill: "#484968"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5876",
    "data-name": "Path 5876",
    d: "M550.139,320.265l-.244-27.015-8.24,2.372-.081,4.925a29.232,29.232,0,0,0,1.261,11.842s1.424,2.607,1.139,8.655C543.994,321.025,547.677,322.89,550.139,320.265Z",
    transform: "translate(-541.429 -293.25)",
    fill: "#f1bb85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13704",
    "data-name": "Group 13704",
    transform: "translate(34.54 20.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5877",
    "data-name": "Path 5877",
    d: "M565.726,301.242h0a3.47,3.47,0,0,1-4.354-1.448l-13.021-25.621a2.805,2.805,0,0,1,1.628-3.875h0a3.47,3.47,0,0,1,4.354,1.448l13.021,25.621A2.81,2.81,0,0,1,565.726,301.242Z",
    transform: "translate(-548.054 -270.034)",
    fill: "#e29d66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13706",
    "data-name": "Group 13706",
    transform: "translate(33.087 23.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5878",
    "data-name": "Path 5878",
    d: "M567.746,296.912,547.34,286.428V271.78l20.406,10.484Z",
    transform: "translate(-547.34 -271.78)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13705",
    "data-name": "Group 13705",
    transform: "translate(11.434 8.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5879",
    "data-name": "Path 5879",
    d: "M554.9,288.439v-11.1l.427.217v11.117Z",
    transform: "translate(-550.953 -275.312)",
    fill: "#a19afb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5880",
    "data-name": "Path 5880",
    d: "M554.41,284.882V277.06l.448.217V285.1Z",
    transform: "translate(-551.46 -275.539)",
    fill: "#a19afb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5881",
    "data-name": "Path 5881",
    d: "M553.93,287.028V276.78l.427.217v10.248Z",
    transform: "translate(-551.957 -275.766)",
    fill: "#a19afb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5882",
    "data-name": "Path 5882",
    d: "M553.44,287.6V276.5l.448.217v11.117Z",
    transform: "translate(-552.464 -275.993)",
    fill: "#a19afb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5883",
    "data-name": "Path 5883",
    d: "M552.96,280.294V276.22l.427.217v4.074Z",
    transform: "translate(-552.96 -276.22)",
    fill: "#a19afb"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5884",
    "data-name": "Path 5884",
    d: "M538.91,294.091v9.977s13.143,3.947,25.473-9.977V284.44Z",
    transform: "translate(-522.975 -237.764)",
    fill: "#ffb200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5885",
    "data-name": "Path 5885",
    d: "M545.161,309.8a1.05,1.05,0,0,0,.427.127c2.2.145,10.112-1.376,18.026-9.325a3.49,3.49,0,0,0,1.078-2.281V275.775a3.6,3.6,0,0,0-1.77-3.44l-5.961-3.1a4.6,4.6,0,0,0-4.252.344l-8.118,4.164c-3.276,1.684-5.961,5.812-5.961,9.18V305.6a1.1,1.1,0,0,0,.57,1.086Z",
    transform: "translate(-523.264 -250.392)",
    fill: "#fdffeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5886",
    "data-name": "Path 5886",
    d: "M542.97,275.53c-.02.561.387,1.123,1.221,1.557a7.231,7.231,0,0,0,5.941,0c.834-.435,1.241-1,1.221-1.557v-4.907c.02-.561-.387-1.123-1.221-1.557a7.231,7.231,0,0,0-5.941,0c-.834.435-1.241,1-1.221,1.557Z",
    transform: "translate(-518.775 -250.744)",
    fill: "#dda26f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13707",
    "data-name": "Group 13707",
    transform: "translate(0 26.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5887",
    "data-name": "Path 5887",
    d: "M532.873,303.925h0A2.792,2.792,0,0,1,531.428,300l14.323-25.24a3.5,3.5,0,0,1,4.415-1.286h0a2.792,2.792,0,0,1,1.445,3.929l-14.323,25.24A3.5,3.5,0,0,1,532.873,303.925Z",
    transform: "translate(-531.078 -273.157)",
    fill: "#f9bb83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13708",
    "data-name": "Group 13708",
    transform: "translate(13.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5888",
    "data-name": "Path 5888",
    d: "M554.9,265.8l4.15,14.34a1.805,1.805,0,0,1-2.543,1.956l-9.542-3.531a1.622,1.622,0,0,1-1.119-1.865l3.133-14.105a1.948,1.948,0,0,1,3.438-.543l2.279,3.3A1.854,1.854,0,0,1,554.9,265.8Z",
    transform: "translate(-529.229 -256.567)",
    fill: "#903bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5889",
    "data-name": "Path 5889",
    d: "M545.333,270.111c0,1.231-.977,1.72-2.157,1.1a4.161,4.161,0,0,1-2.156-3.332c0-1.231.977-1.72,2.156-1.1A4.209,4.209,0,0,1,545.333,270.111Z",
    transform: "translate(-534.185 -252.296)",
    fill: "#f9bb83"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18431",
    "data-name": "Ellipse 18431",
    cx: 11.556,
    cy: 10.284,
    rx: 11.556,
    ry: 10.284,
    transform: "translate(3.397 1.682)",
    fill: "#f9bb83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5890",
    "data-name": "Path 5890",
    d: "M539.647,272s9.766,4.762,14.527-7.641a8.143,8.143,0,0,0,8.891,4.074s0-8.148-9.461-9.741C553.6,258.713,536.88,257.229,539.647,272Z",
    transform: "translate(-535.925 -258.661)",
    fill: "#903bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5891",
    "data-name": "Path 5891",
    d: "M546.754,268.289l4.15,14.34a1.805,1.805,0,0,1-2.543,1.955l-9.542-3.531a1.622,1.622,0,0,1-1.119-1.865l3.133-14.1a1.948,1.948,0,0,1,3.438-.543l2.279,3.3A1.852,1.852,0,0,1,546.754,268.289Z",
    transform: "translate(-537.661 -254.549)",
    fill: "#903bbb"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13716",
    "data-name": "Group 13716",
    transform: "translate(323.297 252.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13710",
    "data-name": "Group 13710",
    transform: "translate(6.807 87.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5892",
    "data-name": "Path 5892",
    d: "M496.79,292.459c-.081,1.2,1.953,2.879,5.046,4.472,4.11,2.118,5.575,4.8,10.661,2.191,1.465-.742,2.075-1.34,2.1-1.865v-2.825c.143-1.3-3.4-2.118-6.348-3.639-4.11-2.119-8.565-3.259-10.661-2.191a1.279,1.279,0,0,0-.814,1.032v2.825Z",
    transform: "translate(-496.77 -288.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5893",
    "data-name": "Path 5893",
    d: "M501.833,294.092c-4.11-2.118-6.368-4.4-4.252-5.486s6.551.072,10.661,2.191,9.339,2.861,4.252,5.486C507.408,298.89,505.943,296.21,501.833,294.092Z",
    transform: "translate(-496.767 -288.191)",
    fill: "#2b0d60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13711",
    "data-name": "Group 13711",
    transform: "translate(18.241 80.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5894",
    "data-name": "Path 5894",
    d: "M502.41,288.579c-.081,1.2,1.953,2.879,5.046,4.472,4.11,2.118,5.575,4.8,10.661,2.191,1.465-.742,2.075-1.34,2.1-1.865v-2.825c.142-1.3-3.4-2.118-6.348-3.639-4.11-2.118-8.565-3.259-10.661-2.191a1.279,1.279,0,0,0-.814,1.032v2.825Z",
    transform: "translate(-502.39 -284.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5895",
    "data-name": "Path 5895",
    d: "M507.463,290.212c-4.11-2.118-6.368-4.4-4.252-5.486s6.551.072,10.661,2.191,9.339,2.861,4.252,5.486C513.038,295.01,511.573,292.33,507.463,290.212Z",
    transform: "translate(-502.377 -284.311)",
    fill: "#2b0d60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13712",
    "data-name": "Group 13712",
    transform: "translate(12.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5896",
    "data-name": "Path 5896",
    d: "M500.984,240.407h0a3.646,3.646,0,0,1,4.659.942l14.059,19.9a2.828,2.828,0,0,1-1.058,4.146h0a3.646,3.646,0,0,1-4.659-.942l-14.059-19.9A2.814,2.814,0,0,1,500.984,240.407Z",
    transform: "translate(-499.403 -239.945)",
    fill: "#fcbdb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5897",
    "data-name": "Path 5897",
    d: "M504.7,254.557l4.537,6.41a5.631,5.631,0,0,0,7.2,1.467h0a4.37,4.37,0,0,0,1.648-6.41l-4.537-6.41C513.571,249.6,507.874,247.695,504.7,254.557Z",
    transform: "translate(-493.923 -232.314)",
    fill: "#293677"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13713",
    "data-name": "Group 13713",
    transform: "translate(14.498 56.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5898",
    "data-name": "Path 5898",
    d: "M510.56,307.03a1.791,1.791,0,0,0,.244-.905V274.691c0-1.992-2.3-3.621-5.127-3.621h0c-2.808,0-5.127,1.63-5.127,3.621v34.185a1.17,1.17,0,0,0,.916,1.1C503.419,310.488,508.078,311.248,510.56,307.03Z",
    transform: "translate(-500.55 -271.07)",
    fill: "#55cdff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13714",
    "data-name": "Group 13714",
    transform: "translate(25.178 49.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5899",
    "data-name": "Path 5899",
    d: "M516.6,302.912a1.837,1.837,0,0,0,.224-.924l-.793-31.415c-.041-1.992-2.4-3.567-5.208-3.513h0c-2.808.054-5.086,1.72-5.025,3.712l.834,34.167a1.194,1.194,0,0,0,.936,1.086C509.565,306.515,514.224,307.185,516.6,302.912Z",
    transform: "translate(-505.799 -267.059)",
    fill: "#55cdff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5900",
    "data-name": "Path 5900",
    d: "M504.794,295.017a1.048,1.048,0,0,0,.427.127c2.258.163,10.4-1.412,18.535-9.578a3.589,3.589,0,0,0,1.1-2.354V260.053a3.659,3.659,0,0,0-1.831-3.531l-6.124-3.169a4.655,4.655,0,0,0-4.354.362l-8.342,4.291c-3.377,1.738-6.124,5.975-6.124,9.452v23.3a1.173,1.173,0,0,0,.59,1.123Z",
    transform: "translate(-488.608 -229.39)",
    fill: "#5258a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5901",
    "data-name": "Path 5901",
    d: "M502.54,259.8c-.02.579.407,1.159,1.261,1.593a7.47,7.47,0,0,0,6.1,0c.855-.435,1.282-1.014,1.261-1.593v-5.052c.02-.579-.407-1.159-1.261-1.593a7.47,7.47,0,0,0-6.1,0c-.854.435-1.282,1.014-1.261,1.593Z",
    transform: "translate(-483.994 -229.768)",
    fill: "#f1bb85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5902",
    "data-name": "Path 5902",
    d: "M522.583,254.024c0,5.848-5.31,10.574-11.882,10.574s-11.882-4.726-11.882-10.574,5.31-10.574,11.882-10.574S522.583,248.194,522.583,254.024Z",
    transform: "translate(-487.842 -237.104)",
    fill: "#fcbdb7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13715",
    "data-name": "Group 13715",
    transform: "translate(0 31.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5903",
    "data-name": "Path 5903",
    d: "M495.715,287.374h0a2.965,2.965,0,0,1-2.116-3.82l8.932-21.51a3.529,3.529,0,0,1,4.293-1.883h0a2.965,2.965,0,0,1,2.116,3.82l-8.932,21.511A3.52,3.52,0,0,1,495.715,287.374Z",
    transform: "translate(-493.424 -254.711)",
    fill: "#fcbdb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5904",
    "data-name": "Path 5904",
    d: "M506.278,270.406l2.747-7.17a4.544,4.544,0,0,0-3.255-5.9h0a5.4,5.4,0,0,0-6.633,2.9l-2.747,7.17S498.3,272.524,506.278,270.406Z",
    transform: "translate(-490.356 -257.081)",
    fill: "#293677"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5905",
    "data-name": "Path 5905",
    d: "M517.417,265.029c-3.743,1.937-6.612.471-7.629-.942-2.564-3.531-2.991-1.177-4.517-2.843-1.994-2.933-1.546-6.917-4.334-8.764-3.988-2.644-2.889-7.912,7.507-10.284,13.957-3.169,19.471,12.493,10.763,21.547A5.54,5.54,0,0,1,517.417,265.029Z",
    transform: "translate(-487.864 -238.458)",
    fill: "#e5a600",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5906",
    "data-name": "Path 5906",
    d: "M503.942,254.984c-1,.887-2.116.634-2.482-.6a4.011,4.011,0,0,1,1.16-3.82c1-.887,2.116-.634,2.482.6A4.011,4.011,0,0,1,503.942,254.984Z",
    transform: "translate(-485.233 -231.763)",
    fill: "#fcbdb7"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13728",
    "data-name": "Group 13728",
    transform: "translate(240.243 354.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13726",
    "data-name": "Group 13726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13724",
    "data-name": "Group 13724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13717",
    "data-name": "Group 13717",
    transform: "translate(19.158 19.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5907",
    "data-name": "Path 5907",
    d: "M482.14,331.465h0a3.237,3.237,0,0,1-4.171-.634l-13.509-17.02a2.483,2.483,0,0,1,.712-3.712h0a3.237,3.237,0,0,1,4.171.634l13.509,17.02A2.485,2.485,0,0,1,482.14,331.465Z",
    transform: "translate(-460.061 -305.334)",
    fill: "#fcbdb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5908",
    "data-name": "Path 5908",
    d: "M474.778,314.476l-4.354-5.486a5.028,5.028,0,0,0-6.45-1h0a3.856,3.856,0,0,0-1.119,5.74l4.354,5.486C467.21,319.238,472.337,320.686,474.778,314.476Z",
    transform: "translate(-462.018 -307.248)",
    fill: "#bdcefa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13718",
    "data-name": "Group 13718",
    transform: "translate(15.649 40.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5909",
    "data-name": "Path 5909",
    d: "M461.344,326.76a1.823,1.823,0,0,0,.692.561l15.768,8.021c1.709.869,4.13.018,5.371-1.9h0c1.241-1.919.855-4.219-.855-5.088l-18.148-9.234a1.25,1.25,0,0,0-1.343.145C461.507,320.35,458.8,323.211,461.344,326.76Z",
    transform: "translate(-460.294 -318.987)",
    fill: "#5258a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13719",
    "data-name": "Group 13719",
    transform: "translate(5.212 45.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5910",
    "data-name": "Path 5910",
    d: "M456.214,329.39a1.822,1.822,0,0,0,.692.561l15.768,8.021c1.709.869,4.13.018,5.371-1.9h0c1.241-1.919.855-4.219-.855-5.088l-18.148-9.234a1.249,1.249,0,0,0-1.343.145C456.377,322.98,453.671,325.841,456.214,329.39Z",
    transform: "translate(-455.164 -321.617)",
    fill: "#5258a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13721",
    "data-name": "Group 13721",
    transform: "translate(30.453 49.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13720",
    "data-name": "Group 13720",
    transform: "translate(0.464 22.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5911",
    "data-name": "Path 5911",
    d: "M467.8,341.847c-.122,1.159,2.991,1.883,5.636,3.241,3.642,1.883,7.589,2.9,9.461,1.937a1.119,1.119,0,0,0,.712-.923v-1.9c.061-1.086-1.729-2.734-4.476-5.106-3.011-2.625-4.944-4.255-9.461-1.937-1.282.67-1.811,1.159-1.811,1.575Z",
    transform: "translate(-467.798 -336.046)",
    fill: "#010400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5912",
    "data-name": "Path 5912",
    d: "M479.1,339.095c3.642,3.169,5.636,5.034,3.764,5.993s-5.615-.489-9.461-3.078c-3.357-2.263-8.281-2.535-3.764-4.853S476.073,336.469,479.1,339.095Z",
    transform: "translate(-467.768 -336.046)",
    fill: "#1c1c38"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5913",
    "data-name": "Path 5913",
    d: "M476.441,346.666a1.627,1.627,0,0,0,.2-.815V327.075c0-1.756-2.034-3.2-4.537-3.2h0c-2.5,0-4.537,1.448-4.537,3.2v21.2a1.033,1.033,0,0,0,.814.978C470.134,349.726,474.264,350.4,476.441,346.666Z",
    transform: "translate(-467.57 -323.87)",
    fill: "#5258a6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5914",
    "data-name": "Path 5914",
    d: "M459.481,343.507a.859.859,0,0,0,.387.109c2.014.145,9.216-1.267,16.439-8.492a3.216,3.216,0,0,0,.977-2.082V312.509a3.284,3.284,0,0,0-1.628-3.133l-5.432-2.825a4.221,4.221,0,0,0-3.866.308l-7.406,3.8c-2.991,1.539-5.432,5.305-5.432,8.365v20.66a1.038,1.038,0,0,0,.529,1Z",
    transform: "translate(-451.652 -288.391)",
    fill: "#fcfdff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13723",
    "data-name": "Group 13723",
    transform: "translate(19.65 54.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13722",
    "data-name": "Group 13722",
    transform: "translate(0.464 22.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5915",
    "data-name": "Path 5915",
    d: "M462.492,344.2c-.122,1.159,2.991,1.883,5.636,3.241,3.642,1.883,7.589,2.9,9.461,1.937a1.12,1.12,0,0,0,.712-.923v-1.9c.061-1.086-1.73-2.734-4.476-5.106-3.011-2.625-4.944-4.255-9.461-1.937-1.282.67-1.811,1.159-1.811,1.575Z",
    transform: "translate(-462.488 -338.396)",
    fill: "#010400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5916",
    "data-name": "Path 5916",
    d: "M473.784,341.445c3.642,3.169,5.636,5.034,3.764,5.993s-5.615-.489-9.461-3.078c-3.357-2.263-8.281-2.535-3.764-4.853S470.773,338.819,473.784,341.445Z",
    transform: "translate(-462.469 -338.396)",
    fill: "#1c1c38"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5917",
    "data-name": "Path 5917",
    d: "M471.131,349.008a1.627,1.627,0,0,0,.2-.815V329.435c0-1.756-2.035-3.2-4.537-3.2h0c-2.5,0-4.537,1.449-4.537,3.2v21.2a1.033,1.033,0,0,0,.814.978C464.8,352.068,468.933,352.738,471.131,349.008Z",
    transform: "translate(-462.26 -326.23)",
    fill: "#5258a6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5918",
    "data-name": "Path 5918",
    d: "M456.85,312.28c-.02.507.366,1.014,1.119,1.412a6.7,6.7,0,0,0,5.412,0c.753-.4,1.139-.905,1.119-1.412v-4.472c.02-.507-.366-1.014-1.119-1.412a6.7,6.7,0,0,0-5.412,0c-.753.4-1.139.905-1.119,1.412Z",
    transform: "translate(-448.208 -288.705)",
    fill: "#f1bb85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5919",
    "data-name": "Path 5919",
    d: "M474.628,307.169c0,5.179-4.72,9.379-10.539,9.379s-10.539-4.2-10.539-9.379,4.72-9.379,10.539-9.379C469.908,297.808,474.628,301.991,474.628,307.169Z",
    transform: "translate(-451.621 -295.219)",
    fill: "#fcbdb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5920",
    "data-name": "Path 5920",
    d: "M459.434,315.672a7.574,7.574,0,0,0,2.177-3.132.826.826,0,0,0,.041-.235v-4.49a4.413,4.413,0,0,1,.773-2.535,2.366,2.366,0,0,1,2.055-1.159s8.443,3.277,11.617-2.843a.794.794,0,0,0-.61-1.141,3.964,3.964,0,0,1-2.279-1.865.949.949,0,0,0-1-.38,3.98,3.98,0,0,1-3.784-1.249.966.966,0,0,0-.692-.272c-1.607.036-7.182.272-10.193,2.209a.11.11,0,0,1-.061.036c-.651.471-11.109,8.4.753,17.093A.917.917,0,0,0,459.434,315.672Z",
    transform: "translate(-452.602 -296.37)",
    fill: "#037fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5921",
    "data-name": "Path 5921",
    d: "M459.007,307.35c0,1.123-.875,1.575-1.974,1.014a3.847,3.847,0,0,1-1.973-3.042c0-1.123.875-1.575,1.973-1.014A3.8,3.8,0,0,1,459.007,307.35Z",
    transform: "translate(-450.059 -290.13)",
    fill: "#fcbdb7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13725",
    "data-name": "Group 13725",
    transform: "translate(5.672 32.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5922",
    "data-name": "Path 5922",
    d: "M488.573,326.782,469.795,336.4l-14.4-6.989,19.226-9.778Z",
    transform: "translate(-455.39 -310.034)",
    fill: "#babeb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5923",
    "data-name": "Path 5923",
    d: "M481.249,331.079l2.95-16.749-20.854,10.683-.875,15.68Z",
    transform: "translate(-448.065 -314.33)",
    fill: "#eaeef1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13727",
    "data-name": "Group 13727",
    transform: "translate(0.027 26.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5924",
    "data-name": "Path 5924",
    d: "M472.921,334.921h0a3.241,3.241,0,0,1-4.171-.634l-13.57-16.966a2.5,2.5,0,0,1,.692-3.712h0a3.259,3.259,0,0,1,4.171.616l13.571,16.966A2.484,2.484,0,0,1,472.921,334.921Z",
    transform: "translate(-450.531 -308.929)",
    fill: "#fcbdb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5925",
    "data-name": "Path 5925",
    d: "M465.036,318.672l-3.784-5.812a4.976,4.976,0,0,0-6.327-1.5h0a3.9,3.9,0,0,0-1.689,5.631l3.784,5.812C457.02,322.819,461.984,324.665,465.036,318.672Z",
    transform: "translate(-452.615 -310.805)",
    fill: "#bdcefa"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13735",
    "data-name": "Group 13735",
    transform: "translate(516.306 303.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13729",
    "data-name": "Group 13729",
    transform: "translate(0.198 22.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5926",
    "data-name": "Path 5926",
    d: "M596.748,300.326h0a3.185,3.185,0,0,0,3.682-2.281l2.319-11.5a2.887,2.887,0,0,0-2.563-3.277h0a3.185,3.185,0,0,0-3.683,2.281l-2.319,11.5A2.878,2.878,0,0,0,596.748,300.326Z",
    transform: "translate(-582.44 -278.133)",
    fill: "#f9bb83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5927",
    "data-name": "Path 5927",
    d: "M594.12,291l1.4-6.989a4.915,4.915,0,0,1,5.7-3.531h0a4.458,4.458,0,0,1,3.967,5.07l-1.4,6.989C603.784,292.521,599.593,295.961,594.12,291Z",
    transform: "translate(-582.457 -280.413)",
    fill: "#d1398f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5928",
    "data-name": "Path 5928",
    d: "M588.535,296.192h0a3.262,3.262,0,0,0,3.967,1.847l10.946-2.843a2.961,2.961,0,0,0,2.95-2.988h0a3.071,3.071,0,0,0-3.357-2.626l-12.431,3.078A2.763,2.763,0,0,0,588.535,296.192Z",
    transform: "translate(-588.387 -272.986)",
    fill: "#f9bb83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13731",
    "data-name": "Group 13731",
    transform: "translate(17.678 51.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13730",
    "data-name": "Group 13730",
    transform: "translate(0 32.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5929",
    "data-name": "Path 5929",
    d: "M613.7,320.708c.142,1.231-3.174,1.992-5.961,3.422-3.866,1.992-8.016,3.06-10.01,2.046a1.145,1.145,0,0,1-.753-.96v-2.01c-.061-1.141,1.831-2.879,4.741-5.4,3.194-2.77,5.229-4.49,10.01-2.046,1.363.706,1.912,1.231,1.912,1.666Z",
    transform: "translate(-596.979 -314.575)",
    fill: "#010400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5930",
    "data-name": "Path 5930",
    d: "M601.721,317.8c-3.866,3.35-5.961,5.323-3.988,6.337s5.941-.507,10.01-3.241c3.561-2.39,8.749-2.68,3.988-5.142C606.971,313.31,604.916,315.03,601.721,317.8Z",
    transform: "translate(-596.979 -314.583)",
    fill: "#1c1c38"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5931",
    "data-name": "Path 5931",
    d: "M600.944,330.114a1.623,1.623,0,0,1-.224-.851V299.786c0-1.865,2.157-3.386,4.8-3.386h0c2.645,0,4.8,1.521,4.8,3.386v32.049a1.109,1.109,0,0,1-.854,1.032C607.638,333.355,603.263,334.062,600.944,330.114Z",
    transform: "translate(-593.109 -296.4)",
    fill: "#46466c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13733",
    "data-name": "Group 13733",
    transform: "translate(7.302 44.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13732",
    "data-name": "Group 13732",
    transform: "translate(0 32.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5932",
    "data-name": "Path 5932",
    d: "M608.6,316.948c.142,1.231-3.174,1.992-5.961,3.422-3.866,1.992-8.016,3.06-10.01,2.046a1.145,1.145,0,0,1-.753-.96v-2.01c-.061-1.141,1.831-2.879,4.74-5.4,3.194-2.77,5.229-4.49,10.01-2.046,1.363.706,1.912,1.231,1.912,1.666Z",
    transform: "translate(-591.879 -310.807)",
    fill: "#010400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5933",
    "data-name": "Path 5933",
    d: "M596.621,314.044c-3.866,3.35-5.961,5.323-3.988,6.337s5.941-.507,10.01-3.241c3.56-2.39,8.748-2.68,3.988-5.142S599.816,311.274,596.621,314.044Z",
    transform: "translate(-591.879 -310.819)",
    fill: "#1c1c38"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5934",
    "data-name": "Path 5934",
    d: "M595.844,326.362a1.581,1.581,0,0,1-.224-.851v-29.5c0-1.865,2.157-3.386,4.8-3.386h0c2.645,0,4.8,1.521,4.8,3.386v32.049a1.109,1.109,0,0,1-.855,1.032C602.517,329.6,598.163,330.31,595.844,326.362Z",
    transform: "translate(-588.009 -292.63)",
    fill: "#2d2d4f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5935",
    "data-name": "Path 5935",
    d: "M614.23,318.865a.958.958,0,0,1-.407.127c-2.116.145-9.745-1.34-17.375-8.981a3.362,3.362,0,0,1-1.038-2.209V286.074a3.447,3.447,0,0,1,1.709-3.313l5.737-2.988a4.419,4.419,0,0,1,4.09.326l7.833,4.02c3.154,1.63,5.737,5.613,5.737,8.854v21.854a1.085,1.085,0,0,1-.549,1.05Z",
    transform: "translate(-580.924 -258.676)",
    fill: "#ed54a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5936",
    "data-name": "Path 5936",
    d: "M607.678,285.822c.02.543-.387,1.086-1.18,1.5a6.991,6.991,0,0,1-5.717,0c-.793-.416-1.2-.96-1.18-1.5V281.1c-.02-.543.387-1.086,1.18-1.5a6.991,6.991,0,0,1,5.717,0c.793.416,1.2.96,1.18,1.5Z",
    transform: "translate(-576.59 -259.021)",
    fill: "#e5a19c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18432",
    "data-name": "Ellipse 18432",
    cx: 11.149,
    cy: 9.922,
    rx: 11.149,
    ry: 9.922,
    transform: "translate(15.89 4.602)",
    fill: "#fcbdb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5937",
    "data-name": "Path 5937",
    d: "M617.261,270.75c9.522,2.915,4.781,15.282-2.136,19.754-3.377-1.648.733-4.6-3.886-2.535-.915-3.984,1.139-2.77-.1-7.786-4.842,2.245-14.262-.471-15.727-4.635,1.689-.67,3.459-4.925,7.406-6.5C607.882,267.038,614.372,267.925,617.261,270.75Z",
    transform: "translate(-580.924 -267.958)",
    fill: "#52a1f6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5938",
    "data-name": "Path 5938",
    d: "M603.41,280.6c0,1.177.936,1.666,2.075,1.068a4.011,4.011,0,0,0,2.075-3.2c0-1.177-.936-1.666-2.075-1.068A4.032,4.032,0,0,0,603.41,280.6Z",
    transform: "translate(-572.648 -260.516)",
    fill: "#fcbdb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5939",
    "data-name": "Path 5939",
    d: "M623.162,300.309l-17.436,8.963-17.436-8.963v-6.826l17.436-8.963,17.436,8.963Z",
    transform: "translate(-588.29 -254.532)",
    fill: "#babeb5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5940",
    "data-name": "Path 5940",
    d: "M605.726,284.52l17.436,8.963-17.436,8.782-17.436-8.782Z",
    transform: "translate(-588.29 -254.532)",
    fill: "#eaeef1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13734",
    "data-name": "Group 13734",
    transform: "translate(16.621 29.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5941",
    "data-name": "Path 5941",
    d: "M606.551,304.171h0a3.128,3.128,0,0,0,3.581-2.39l1.851-11.552a2.891,2.891,0,0,0-2.686-3.187h0a3.128,3.128,0,0,0-3.581,2.39l-1.851,11.552A2.925,2.925,0,0,0,606.551,304.171Z",
    transform: "translate(-588.829 -281.855)",
    fill: "#f9bb83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5942",
    "data-name": "Path 5942",
    d: "M603.65,294.947l1.139-7.043a4.852,4.852,0,0,1,5.554-3.694h0a4.481,4.481,0,0,1,4.151,4.943l-1.139,7.043C613.355,296.179,609.306,299.746,603.65,294.947Z",
    transform: "translate(-589.021 -284.165)",
    fill: "#d1398f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5943",
    "data-name": "Path 5943",
    d: "M596.644,301.624h0a3.29,3.29,0,0,0,4.049,1.72L614.934,299a2.944,2.944,0,0,0,2.848-3.078h0a3.107,3.107,0,0,0-3.459-2.535L598.6,298.021A2.748,2.748,0,0,0,596.644,301.624Z",
    transform: "translate(-596.46 -276.701)",
    fill: "#f9bb83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHeader);
export default __webpack_public_path__ + "static/media/homeHeader.98178888135ac5ef9b5c4be5400f5b60.svg";
export { ForwardRef as ReactComponent };